var cov_172wm16s2f = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/activity_dashboard/activityDashboardGlobalCtrl.js',
      hash = '590dff2f93d9ea05090c77ecfa6d34698d1ede37',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/activity_dashboard/activityDashboardGlobalCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 767,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 26
        }
      },
      '2': {
        start: {
          line: 3,
          column: 24
        },
        end: {
          line: 3,
          column: 35
        }
      },
      '3': {
        start: {
          line: 4,
          column: 18
        },
        end: {
          line: 4,
          column: 32
        }
      },
      '4': {
        start: {
          line: 5,
          column: 18
        },
        end: {
          line: 5,
          column: 33
        }
      },
      '5': {
        start: {
          line: 7,
          column: 53
        },
        end: {
          line: 7,
          column: 136
        }
      },
      '6': {
        start: {
          line: 9,
          column: 53
        },
        end: {
          line: 9,
          column: 136
        }
      },
      '7': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 52
        }
      },
      '8': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 18,
          column: 4
        }
      },
      '9': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 22
        }
      },
      '10': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 26
        }
      },
      '11': {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 50
        }
      },
      '12': {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 50,
          column: 3
        }
      },
      '13': {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 104
        }
      },
      '14': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 48,
          column: 5
        }
      },
      '15': {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 105
        }
      },
      '16': {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 14
        }
      },
      '17': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 108
        }
      },
      '18': {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 14
        }
      },
      '19': {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 108
        }
      },
      '20': {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 14
        }
      },
      '21': {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 108
        }
      },
      '22': {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 14
        }
      },
      '23': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 108
        }
      },
      '24': {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 14
        }
      },
      '25': {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 105
        }
      },
      '26': {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 14
        }
      },
      '27': {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 122
        }
      },
      '28': {
        start: {
          line: 52,
          column: 21
        },
        end: {
          line: 86,
          column: 3
        }
      },
      '29': {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 85,
          column: 7
        }
      },
      '30': {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 46
        }
      },
      '31': {
        start: {
          line: 88,
          column: 19
        },
        end: {
          line: 97,
          column: 3
        }
      },
      '32': {
        start: {
          line: 89,
          column: 19
        },
        end: {
          line: 91,
          column: 6
        }
      },
      '33': {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 34
        }
      },
      '34': {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 95,
          column: 5
        }
      },
      '35': {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 29
        }
      },
      '36': {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 68
        }
      },
      '37': {
        start: {
          line: 99,
          column: 24
        },
        end: {
          line: 222,
          column: 3
        }
      },
      '38': {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 102,
          column: 5
        }
      },
      '39': {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 13
        }
      },
      '40': {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      '41': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 13
        }
      },
      '42': {
        start: {
          line: 107,
          column: 18
        },
        end: {
          line: 107,
          column: 54
        }
      },
      '43': {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 16
        }
      },
      '44': {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 121,
          column: 5
        }
      },
      '45': {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 119,
          column: 9
        }
      },
      '46': {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 118,
          column: 10
        }
      },
      '47': {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 120,
          column: 13
        }
      },
      '48': {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 210,
          column: 7
        }
      },
      '49': {
        start: {
          line: 123,
          column: 20
        },
        end: {
          line: 126,
          column: 40
        }
      },
      '50': {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 209,
          column: 9
        }
      },
      '51': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 35
        }
      },
      '52': {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 136,
          column: 11
        }
      },
      '53': {
        start: {
          line: 135,
          column: 10
        },
        end: {
          line: 135,
          column: 48
        }
      },
      '54': {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 145,
          column: 11
        }
      },
      '55': {
        start: {
          line: 139,
          column: 22
        },
        end: {
          line: 139,
          column: 41
        }
      },
      '56': {
        start: {
          line: 140,
          column: 10
        },
        end: {
          line: 140,
          column: 31
        }
      },
      '57': {
        start: {
          line: 141,
          column: 10
        },
        end: {
          line: 143,
          column: 11
        }
      },
      '58': {
        start: {
          line: 142,
          column: 12
        },
        end: {
          line: 142,
          column: 73
        }
      },
      '59': {
        start: {
          line: 144,
          column: 10
        },
        end: {
          line: 144,
          column: 23
        }
      },
      '60': {
        start: {
          line: 146,
          column: 22
        },
        end: {
          line: 207,
          column: 10
        }
      },
      '61': {
        start: {
          line: 173,
          column: 27
        },
        end: {
          line: 173,
          column: 52
        }
      },
      '62': {
        start: {
          line: 174,
          column: 16
        },
        end: {
          line: 176,
          column: 17
        }
      },
      '63': {
        start: {
          line: 175,
          column: 18
        },
        end: {
          line: 175,
          column: 34
        }
      },
      '64': {
        start: {
          line: 177,
          column: 16
        },
        end: {
          line: 177,
          column: 26
        }
      },
      '65': {
        start: {
          line: 184,
          column: 27
        },
        end: {
          line: 184,
          column: 52
        }
      },
      '66': {
        start: {
          line: 185,
          column: 16
        },
        end: {
          line: 187,
          column: 17
        }
      },
      '67': {
        start: {
          line: 186,
          column: 18
        },
        end: {
          line: 186,
          column: 34
        }
      },
      '68': {
        start: {
          line: 188,
          column: 16
        },
        end: {
          line: 188,
          column: 26
        }
      },
      '69': {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 208,
          column: 39
        }
      },
      '70': {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 221,
          column: 7
        }
      },
      '71': {
        start: {
          line: 212,
          column: 21
        },
        end: {
          line: 219,
          column: 7
        }
      },
      '72': {
        start: {
          line: 220,
          column: 6
        },
        end: {
          line: 220,
          column: 20
        }
      },
      '73': {
        start: {
          line: 223,
          column: 2
        },
        end: {
          line: 223,
          column: 28
        }
      },
      '74': {
        start: {
          line: 224,
          column: 2
        },
        end: {
          line: 224,
          column: 38
        }
      },
      '75': {
        start: {
          line: 225,
          column: 2
        },
        end: {
          line: 225,
          column: 36
        }
      },
      '76': {
        start: {
          line: 227,
          column: 2
        },
        end: {
          line: 229,
          column: 5
        }
      },
      '77': {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 228,
          column: 32
        }
      },
      '78': {
        start: {
          line: 231,
          column: 2
        },
        end: {
          line: 247,
          column: 5
        }
      },
      '79': {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 234,
          column: 5
        }
      },
      '80': {
        start: {
          line: 233,
          column: 6
        },
        end: {
          line: 233,
          column: 16
        }
      },
      '81': {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 237,
          column: 5
        }
      },
      '82': {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 236,
          column: 81
        }
      },
      '83': {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 241,
          column: 5
        }
      },
      '84': {
        start: {
          line: 240,
          column: 6
        },
        end: {
          line: 240,
          column: 87
        }
      },
      '85': {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 245,
          column: 5
        }
      },
      '86': {
        start: {
          line: 244,
          column: 6
        },
        end: {
          line: 244,
          column: 80
        }
      },
      '87': {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 246,
          column: 14
        }
      },
      '88': {
        start: {
          line: 249,
          column: 2
        },
        end: {
          line: 249,
          column: 25
        }
      },
      '89': {
        start: {
          line: 251,
          column: 25
        },
        end: {
          line: 272,
          column: 3
        }
      },
      '90': {
        start: {
          line: 252,
          column: 23
        },
        end: {
          line: 262,
          column: 5
        }
      },
      '91': {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 266,
          column: 5
        }
      },
      '92': {
        start: {
          line: 265,
          column: 6
        },
        end: {
          line: 265,
          column: 27
        }
      },
      '93': {
        start: {
          line: 267,
          column: 4
        },
        end: {
          line: 271,
          column: 7
        }
      },
      '94': {
        start: {
          line: 268,
          column: 6
        },
        end: {
          line: 270,
          column: 7
        }
      },
      '95': {
        start: {
          line: 269,
          column: 8
        },
        end: {
          line: 269,
          column: 27
        }
      },
      '96': {
        start: {
          line: 274,
          column: 2
        },
        end: {
          line: 288,
          column: 4
        }
      },
      '97': {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 283,
          column: 5
        }
      },
      '98': {
        start: {
          line: 276,
          column: 6
        },
        end: {
          line: 276,
          column: 29
        }
      },
      '99': {
        start: {
          line: 277,
          column: 6
        },
        end: {
          line: 277,
          column: 80
        }
      },
      '100': {
        start: {
          line: 278,
          column: 6
        },
        end: {
          line: 278,
          column: 26
        }
      },
      '101': {
        start: {
          line: 280,
          column: 6
        },
        end: {
          line: 282,
          column: 9
        }
      },
      '102': {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 281,
          column: 67
        }
      },
      '103': {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 284,
          column: 36
        }
      },
      '104': {
        start: {
          line: 285,
          column: 4
        },
        end: {
          line: 285,
          column: 35
        }
      },
      '105': {
        start: {
          line: 286,
          column: 4
        },
        end: {
          line: 286,
          column: 34
        }
      },
      '106': {
        start: {
          line: 287,
          column: 4
        },
        end: {
          line: 287,
          column: 32
        }
      },
      '107': {
        start: {
          line: 291,
          column: 2
        },
        end: {
          line: 295,
          column: 4
        }
      },
      '108': {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 292,
          column: 35
        }
      },
      '109': {
        start: {
          line: 293,
          column: 4
        },
        end: {
          line: 293,
          column: 34
        }
      },
      '110': {
        start: {
          line: 294,
          column: 4
        },
        end: {
          line: 294,
          column: 32
        }
      },
      '111': {
        start: {
          line: 297,
          column: 2
        },
        end: {
          line: 310,
          column: 5
        }
      },
      '112': {
        start: {
          line: 298,
          column: 4
        },
        end: {
          line: 298,
          column: 30
        }
      },
      '113': {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 309,
          column: 7
        }
      },
      '114': {
        start: {
          line: 300,
          column: 6
        },
        end: {
          line: 308,
          column: 7
        }
      },
      '115': {
        start: {
          line: 301,
          column: 8
        },
        end: {
          line: 301,
          column: 37
        }
      },
      '116': {
        start: {
          line: 303,
          column: 8
        },
        end: {
          line: 307,
          column: 9
        }
      },
      '117': {
        start: {
          line: 304,
          column: 10
        },
        end: {
          line: 306,
          column: 13
        }
      },
      '118': {
        start: {
          line: 305,
          column: 12
        },
        end: {
          line: 305,
          column: 60
        }
      },
      '119': {
        start: {
          line: 312,
          column: 2
        },
        end: {
          line: 318,
          column: 4
        }
      },
      '120': {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 313,
          column: 31
        }
      },
      '121': {
        start: {
          line: 314,
          column: 4
        },
        end: {
          line: 314,
          column: 36
        }
      },
      '122': {
        start: {
          line: 316,
          column: 4
        },
        end: {
          line: 316,
          column: 92
        }
      },
      '123': {
        start: {
          line: 317,
          column: 4
        },
        end: {
          line: 317,
          column: 32
        }
      },
      '124': {
        start: {
          line: 320,
          column: 2
        },
        end: {
          line: 445,
          column: 4
        }
      },
      '125': {
        start: {
          line: 321,
          column: 4
        },
        end: {
          line: 321,
          column: 30
        }
      },
      '126': {
        start: {
          line: 322,
          column: 4
        },
        end: {
          line: 324,
          column: 5
        }
      },
      '127': {
        start: {
          line: 323,
          column: 6
        },
        end: {
          line: 323,
          column: 13
        }
      },
      '128': {
        start: {
          line: 325,
          column: 4
        },
        end: {
          line: 444,
          column: 7
        }
      },
      '129': {
        start: {
          line: 326,
          column: 6
        },
        end: {
          line: 326,
          column: 32
        }
      },
      '130': {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 327,
          column: 39
        }
      },
      '131': {
        start: {
          line: 328,
          column: 6
        },
        end: {
          line: 328,
          column: 41
        }
      },
      '132': {
        start: {
          line: 329,
          column: 6
        },
        end: {
          line: 329,
          column: 38
        }
      },
      '133': {
        start: {
          line: 332,
          column: 6
        },
        end: {
          line: 368,
          column: 7
        }
      },
      '134': {
        start: {
          line: 334,
          column: 10
        },
        end: {
          line: 366,
          column: 12
        }
      },
      '135': {
        start: {
          line: 367,
          column: 8
        },
        end: {
          line: 367,
          column: 53
        }
      },
      '136': {
        start: {
          line: 370,
          column: 6
        },
        end: {
          line: 399,
          column: 7
        }
      },
      '137': {
        start: {
          line: 371,
          column: 30
        },
        end: {
          line: 397,
          column: 10
        }
      },
      '138': {
        start: {
          line: 398,
          column: 8
        },
        end: {
          line: 398,
          column: 55
        }
      },
      '139': {
        start: {
          line: 401,
          column: 6
        },
        end: {
          line: 443,
          column: 7
        }
      },
      '140': {
        start: {
          line: 402,
          column: 19
        },
        end: {
          line: 402,
          column: 64
        }
      },
      '141': {
        start: {
          line: 403,
          column: 19
        },
        end: {
          line: 403,
          column: 64
        }
      },
      '142': {
        start: {
          line: 404,
          column: 23
        },
        end: {
          line: 404,
          column: 47
        }
      },
      '143': {
        start: {
          line: 405,
          column: 21
        },
        end: {
          line: 405,
          column: 25
        }
      },
      '144': {
        start: {
          line: 406,
          column: 8
        },
        end: {
          line: 442,
          column: 9
        }
      },
      '145': {
        start: {
          line: 407,
          column: 10
        },
        end: {
          line: 407,
          column: 53
        }
      },
      '146': {
        start: {
          line: 408,
          column: 10
        },
        end: {
          line: 410,
          column: 11
        }
      },
      '147': {
        start: {
          line: 409,
          column: 12
        },
        end: {
          line: 409,
          column: 25
        }
      },
      '148': {
        start: {
          line: 411,
          column: 10
        },
        end: {
          line: 413,
          column: 11
        }
      },
      '149': {
        start: {
          line: 412,
          column: 12
        },
        end: {
          line: 412,
          column: 23
        }
      },
      '150': {
        start: {
          line: 414,
          column: 32
        },
        end: {
          line: 440,
          column: 12
        }
      },
      '151': {
        start: {
          line: 441,
          column: 10
        },
        end: {
          line: 441,
          column: 54
        }
      },
      '152': {
        start: {
          line: 447,
          column: 2
        },
        end: {
          line: 534,
          column: 4
        }
      },
      '153': {
        start: {
          line: 448,
          column: 4
        },
        end: {
          line: 450,
          column: 5
        }
      },
      '154': {
        start: {
          line: 449,
          column: 6
        },
        end: {
          line: 449,
          column: 13
        }
      },
      '155': {
        start: {
          line: 452,
          column: 4
        },
        end: {
          line: 533,
          column: 7
        }
      },
      '156': {
        start: {
          line: 457,
          column: 6
        },
        end: {
          line: 459,
          column: 9
        }
      },
      '157': {
        start: {
          line: 458,
          column: 8
        },
        end: {
          line: 458,
          column: 46
        }
      },
      '158': {
        start: {
          line: 461,
          column: 6
        },
        end: {
          line: 468,
          column: 9
        }
      },
      '159': {
        start: {
          line: 462,
          column: 20
        },
        end: {
          line: 462,
          column: 39
        }
      },
      '160': {
        start: {
          line: 463,
          column: 8
        },
        end: {
          line: 463,
          column: 29
        }
      },
      '161': {
        start: {
          line: 464,
          column: 8
        },
        end: {
          line: 466,
          column: 9
        }
      },
      '162': {
        start: {
          line: 465,
          column: 10
        },
        end: {
          line: 465,
          column: 71
        }
      },
      '163': {
        start: {
          line: 467,
          column: 8
        },
        end: {
          line: 467,
          column: 21
        }
      },
      '164': {
        start: {
          line: 470,
          column: 6
        },
        end: {
          line: 531,
          column: 9
        }
      },
      '165': {
        start: {
          line: 497,
          column: 25
        },
        end: {
          line: 497,
          column: 50
        }
      },
      '166': {
        start: {
          line: 498,
          column: 14
        },
        end: {
          line: 500,
          column: 15
        }
      },
      '167': {
        start: {
          line: 499,
          column: 16
        },
        end: {
          line: 499,
          column: 32
        }
      },
      '168': {
        start: {
          line: 501,
          column: 14
        },
        end: {
          line: 501,
          column: 24
        }
      },
      '169': {
        start: {
          line: 508,
          column: 25
        },
        end: {
          line: 508,
          column: 50
        }
      },
      '170': {
        start: {
          line: 509,
          column: 14
        },
        end: {
          line: 511,
          column: 15
        }
      },
      '171': {
        start: {
          line: 510,
          column: 16
        },
        end: {
          line: 510,
          column: 32
        }
      },
      '172': {
        start: {
          line: 512,
          column: 14
        },
        end: {
          line: 512,
          column: 24
        }
      },
      '173': {
        start: {
          line: 536,
          column: 19
        },
        end: {
          line: 563,
          column: 3
        }
      },
      '174': {
        start: {
          line: 537,
          column: 18
        },
        end: {
          line: 542,
          column: 45
        }
      },
      '175': {
        start: {
          line: 544,
          column: 4
        },
        end: {
          line: 544,
          column: 56
        }
      },
      '176': {
        start: {
          line: 545,
          column: 4
        },
        end: {
          line: 545,
          column: 40
        }
      },
      '177': {
        start: {
          line: 547,
          column: 4
        },
        end: {
          line: 547,
          column: 36
        }
      },
      '178': {
        start: {
          line: 548,
          column: 22
        },
        end: {
          line: 548,
          column: 34
        }
      },
      '179': {
        start: {
          line: 549,
          column: 26
        },
        end: {
          line: 549,
          column: 62
        }
      },
      '180': {
        start: {
          line: 550,
          column: 4
        },
        end: {
          line: 561,
          column: 6
        }
      },
      '181': {
        start: {
          line: 551,
          column: 18
        },
        end: {
          line: 551,
          column: 56
        }
      },
      '182': {
        start: {
          line: 553,
          column: 6
        },
        end: {
          line: 559,
          column: 7
        }
      },
      '183': {
        start: {
          line: 554,
          column: 8
        },
        end: {
          line: 558,
          column: 125
        }
      },
      '184': {
        start: {
          line: 560,
          column: 6
        },
        end: {
          line: 560,
          column: 17
        }
      },
      '185': {
        start: {
          line: 562,
          column: 4
        },
        end: {
          line: 562,
          column: 31
        }
      },
      '186': {
        start: {
          line: 564,
          column: 24
        },
        end: {
          line: 596,
          column: 3
        }
      },
      '187': {
        start: {
          line: 565,
          column: 4
        },
        end: {
          line: 565,
          column: 50
        }
      },
      '188': {
        start: {
          line: 566,
          column: 14
        },
        end: {
          line: 588,
          column: 6
        }
      },
      '189': {
        start: {
          line: 569,
          column: 8
        },
        end: {
          line: 569,
          column: 49
        }
      },
      '190': {
        start: {
          line: 573,
          column: 8
        },
        end: {
          line: 576,
          column: 11
        }
      },
      '191': {
        start: {
          line: 579,
          column: 8
        },
        end: {
          line: 586,
          column: 10
        }
      },
      '192': {
        start: {
          line: 589,
          column: 4
        },
        end: {
          line: 592,
          column: 7
        }
      },
      '193': {
        start: {
          line: 590,
          column: 6
        },
        end: {
          line: 590,
          column: 52
        }
      },
      '194': {
        start: {
          line: 591,
          column: 6
        },
        end: {
          line: 591,
          column: 71
        }
      },
      '195': {
        start: {
          line: 593,
          column: 4
        },
        end: {
          line: 593,
          column: 32
        }
      },
      '196': {
        start: {
          line: 594,
          column: 4
        },
        end: {
          line: 594,
          column: 21
        }
      },
      '197': {
        start: {
          line: 595,
          column: 4
        },
        end: {
          line: 595,
          column: 25
        }
      },
      '198': {
        start: {
          line: 598,
          column: 25
        },
        end: {
          line: 689,
          column: 3
        }
      },
      '199': {
        start: {
          line: 599,
          column: 23
        },
        end: {
          line: 599,
          column: 25
        }
      },
      '200': {
        start: {
          line: 600,
          column: 16
        },
        end: {
          line: 600,
          column: 18
        }
      },
      '201': {
        start: {
          line: 601,
          column: 4
        },
        end: {
          line: 608,
          column: 5
        }
      },
      '202': {
        start: {
          line: 602,
          column: 22
        },
        end: {
          line: 602,
          column: 68
        }
      },
      '203': {
        start: {
          line: 603,
          column: 6
        },
        end: {
          line: 605,
          column: 7
        }
      },
      '204': {
        start: {
          line: 604,
          column: 8
        },
        end: {
          line: 604,
          column: 17
        }
      },
      '205': {
        start: {
          line: 606,
          column: 6
        },
        end: {
          line: 606,
          column: 24
        }
      },
      '206': {
        start: {
          line: 607,
          column: 6
        },
        end: {
          line: 607,
          column: 41
        }
      },
      '207': {
        start: {
          line: 610,
          column: 19
        },
        end: {
          line: 652,
          column: 5
        }
      },
      '208': {
        start: {
          line: 654,
          column: 4
        },
        end: {
          line: 669,
          column: 7
        }
      },
      '209': {
        start: {
          line: 655,
          column: 19
        },
        end: {
          line: 655,
          column: 23
        }
      },
      '210': {
        start: {
          line: 656,
          column: 6
        },
        end: {
          line: 665,
          column: 7
        }
      },
      '211': {
        start: {
          line: 657,
          column: 22
        },
        end: {
          line: 657,
          column: 70
        }
      },
      '212': {
        start: {
          line: 658,
          column: 25
        },
        end: {
          line: 658,
          column: 53
        }
      },
      '213': {
        start: {
          line: 660,
          column: 8
        },
        end: {
          line: 664,
          column: 9
        }
      },
      '214': {
        start: {
          line: 661,
          column: 10
        },
        end: {
          line: 661,
          column: 28
        }
      },
      '215': {
        start: {
          line: 663,
          column: 10
        },
        end: {
          line: 663,
          column: 34
        }
      },
      '216': {
        start: {
          line: 666,
          column: 6
        },
        end: {
          line: 668,
          column: 7
        }
      },
      '217': {
        start: {
          line: 667,
          column: 8
        },
        end: {
          line: 667,
          column: 50
        }
      },
      '218': {
        start: {
          line: 691,
          column: 2
        },
        end: {
          line: 736,
          column: 4
        }
      },
      '219': {
        start: {
          line: 692,
          column: 4
        },
        end: {
          line: 694,
          column: 5
        }
      },
      '220': {
        start: {
          line: 693,
          column: 6
        },
        end: {
          line: 693,
          column: 16
        }
      },
      '221': {
        start: {
          line: 696,
          column: 19
        },
        end: {
          line: 696,
          column: 71
        }
      },
      '222': {
        start: {
          line: 697,
          column: 4
        },
        end: {
          line: 699,
          column: 5
        }
      },
      '223': {
        start: {
          line: 698,
          column: 6
        },
        end: {
          line: 698,
          column: 43
        }
      },
      '224': {
        start: {
          line: 700,
          column: 4
        },
        end: {
          line: 700,
          column: 24
        }
      },
      '225': {
        start: {
          line: 701,
          column: 4
        },
        end: {
          line: 735,
          column: 7
        }
      },
      '226': {
        start: {
          line: 706,
          column: 6
        },
        end: {
          line: 706,
          column: 28
        }
      },
      '227': {
        start: {
          line: 708,
          column: 6
        },
        end: {
          line: 718,
          column: 7
        }
      },
      '228': {
        start: {
          line: 709,
          column: 8
        },
        end: {
          line: 712,
          column: 9
        }
      },
      '229': {
        start: {
          line: 710,
          column: 27
        },
        end: {
          line: 710,
          column: 65
        }
      },
      '230': {
        start: {
          line: 711,
          column: 10
        },
        end: {
          line: 711,
          column: 75
        }
      },
      '231': {
        start: {
          line: 713,
          column: 13
        },
        end: {
          line: 718,
          column: 7
        }
      },
      '232': {
        start: {
          line: 715,
          column: 8
        },
        end: {
          line: 715,
          column: 40
        }
      },
      '233': {
        start: {
          line: 716,
          column: 8
        },
        end: {
          line: 716,
          column: 41
        }
      },
      '234': {
        start: {
          line: 717,
          column: 8
        },
        end: {
          line: 717,
          column: 15
        }
      },
      '235': {
        start: {
          line: 720,
          column: 6
        },
        end: {
          line: 734,
          column: 7
        }
      },
      '236': {
        start: {
          line: 722,
          column: 8
        },
        end: {
          line: 722,
          column: 41
        }
      },
      '237': {
        start: {
          line: 725,
          column: 8
        },
        end: {
          line: 733,
          column: 11
        }
      },
      '238': {
        start: {
          line: 726,
          column: 10
        },
        end: {
          line: 726,
          column: 40
        }
      },
      '239': {
        start: {
          line: 727,
          column: 10
        },
        end: {
          line: 729,
          column: 11
        }
      },
      '240': {
        start: {
          line: 728,
          column: 12
        },
        end: {
          line: 728,
          column: 66
        }
      },
      '241': {
        start: {
          line: 730,
          column: 10
        },
        end: {
          line: 732,
          column: 11
        }
      },
      '242': {
        start: {
          line: 731,
          column: 12
        },
        end: {
          line: 731,
          column: 28
        }
      },
      '243': {
        start: {
          line: 737,
          column: 2
        },
        end: {
          line: 740,
          column: 5
        }
      },
      '244': {
        start: {
          line: 738,
          column: 23
        },
        end: {
          line: 738,
          column: 92
        }
      },
      '245': {
        start: {
          line: 739,
          column: 4
        },
        end: {
          line: 739,
          column: 134
        }
      },
      '246': {
        start: {
          line: 739,
          column: 71
        },
        end: {
          line: 739,
          column: 94
        }
      },
      '247': {
        start: {
          line: 742,
          column: 2
        },
        end: {
          line: 742,
          column: 30
        }
      },
      '248': {
        start: {
          line: 743,
          column: 2
        },
        end: {
          line: 743,
          column: 31
        }
      },
      '249': {
        start: {
          line: 744,
          column: 2
        },
        end: {
          line: 752,
          column: 4
        }
      },
      '250': {
        start: {
          line: 745,
          column: 4
        },
        end: {
          line: 751,
          column: 5
        }
      },
      '251': {
        start: {
          line: 746,
          column: 6
        },
        end: {
          line: 748,
          column: 9
        }
      },
      '252': {
        start: {
          line: 747,
          column: 8
        },
        end: {
          line: 747,
          column: 121
        }
      },
      '253': {
        start: {
          line: 750,
          column: 6
        },
        end: {
          line: 750,
          column: 60
        }
      },
      '254': {
        start: {
          line: 755,
          column: 2
        },
        end: {
          line: 766,
          column: 5
        }
      },
      '255': {
        start: {
          line: 756,
          column: 4
        },
        end: {
          line: 756,
          column: 27
        }
      },
      '256': {
        start: {
          line: 757,
          column: 4
        },
        end: {
          line: 757,
          column: 47
        }
      },
      '257': {
        start: {
          line: 759,
          column: 27
        },
        end: {
          line: 759,
          column: 91
        }
      },
      '258': {
        start: {
          line: 761,
          column: 4
        },
        end: {
          line: 765,
          column: 6
        }
      },
      '259': {
        start: {
          line: 762,
          column: 40
        },
        end: {
          line: 762,
          column: 69
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 64
          },
          end: {
            line: 1,
            column: 65
          }
        },
        loc: {
          start: {
            line: 1,
            column: 206
          },
          end: {
            line: 767,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 24,
            column: 21
          },
          end: {
            line: 24,
            column: 22
          }
        },
        loc: {
          start: {
            line: 24,
            column: 30
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 24
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 52,
            column: 21
          },
          end: {
            line: 52,
            column: 22
          }
        },
        loc: {
          start: {
            line: 52,
            column: 29
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 52
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 83,
            column: 13
          },
          end: {
            line: 83,
            column: 14
          }
        },
        loc: {
          start: {
            line: 83,
            column: 23
          },
          end: {
            line: 85,
            column: 5
          }
        },
        line: 83
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 88,
            column: 19
          },
          end: {
            line: 88,
            column: 20
          }
        },
        loc: {
          start: {
            line: 88,
            column: 42
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 88
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 89,
            column: 42
          },
          end: {
            line: 89,
            column: 43
          }
        },
        loc: {
          start: {
            line: 89,
            column: 49
          },
          end: {
            line: 91,
            column: 5
          }
        },
        line: 89
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 99,
            column: 24
          },
          end: {
            line: 99,
            column: 25
          }
        },
        loc: {
          start: {
            line: 99,
            column: 44
          },
          end: {
            line: 222,
            column: 3
          }
        },
        line: 99
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 110,
            column: 21
          },
          end: {
            line: 110,
            column: 22
          }
        },
        loc: {
          start: {
            line: 110,
            column: 27
          },
          end: {
            line: 119,
            column: 7
          }
        },
        line: 110
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 122,
            column: 22
          },
          end: {
            line: 122,
            column: 23
          }
        },
        loc: {
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 210,
            column: 5
          }
        },
        line: 122
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 132,
            column: 9
          },
          end: {
            line: 132,
            column: 10
          }
        },
        loc: {
          start: {
            line: 132,
            column: 17
          },
          end: {
            line: 209,
            column: 7
          }
        },
        line: 132
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 134,
            column: 26
          }
        },
        loc: {
          start: {
            line: 134,
            column: 45
          },
          end: {
            line: 136,
            column: 9
          }
        },
        line: 134
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 138,
            column: 24
          },
          end: {
            line: 138,
            column: 25
          }
        },
        loc: {
          start: {
            line: 138,
            column: 33
          },
          end: {
            line: 145,
            column: 9
          }
        },
        line: 138
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 172,
            column: 35
          },
          end: {
            line: 172,
            column: 36
          }
        },
        loc: {
          start: {
            line: 172,
            column: 44
          },
          end: {
            line: 178,
            column: 15
          }
        },
        line: 172
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 183,
            column: 35
          },
          end: {
            line: 183,
            column: 36
          }
        },
        loc: {
          start: {
            line: 183,
            column: 44
          },
          end: {
            line: 189,
            column: 15
          }
        },
        line: 183
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 211,
            column: 19
          },
          end: {
            line: 211,
            column: 20
          }
        },
        loc: {
          start: {
            line: 211,
            column: 25
          },
          end: {
            line: 221,
            column: 5
          }
        },
        line: 211
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 227,
            column: 64
          },
          end: {
            line: 227,
            column: 65
          }
        },
        loc: {
          start: {
            line: 227,
            column: 72
          },
          end: {
            line: 229,
            column: 3
          }
        },
        line: 227
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 231,
            column: 21
          },
          end: {
            line: 231,
            column: 22
          }
        },
        loc: {
          start: {
            line: 231,
            column: 27
          },
          end: {
            line: 247,
            column: 3
          }
        },
        line: 231
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 251,
            column: 25
          },
          end: {
            line: 251,
            column: 26
          }
        },
        loc: {
          start: {
            line: 251,
            column: 57
          },
          end: {
            line: 272,
            column: 3
          }
        },
        line: 251
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 267,
            column: 73
          },
          end: {
            line: 267,
            column: 74
          }
        },
        loc: {
          start: {
            line: 267,
            column: 81
          },
          end: {
            line: 271,
            column: 5
          }
        },
        line: 267
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 274,
            column: 30
          },
          end: {
            line: 274,
            column: 31
          }
        },
        loc: {
          start: {
            line: 274,
            column: 46
          },
          end: {
            line: 288,
            column: 3
          }
        },
        line: 274
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 280,
            column: 100
          },
          end: {
            line: 280,
            column: 101
          }
        },
        loc: {
          start: {
            line: 280,
            column: 112
          },
          end: {
            line: 282,
            column: 7
          }
        },
        line: 280
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 291,
            column: 31
          },
          end: {
            line: 291,
            column: 32
          }
        },
        loc: {
          start: {
            line: 291,
            column: 43
          },
          end: {
            line: 295,
            column: 3
          }
        },
        line: 291
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 297,
            column: 23
          },
          end: {
            line: 297,
            column: 24
          }
        },
        loc: {
          start: {
            line: 297,
            column: 29
          },
          end: {
            line: 310,
            column: 3
          }
        },
        line: 297
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 299,
            column: 74
          },
          end: {
            line: 299,
            column: 75
          }
        },
        loc: {
          start: {
            line: 299,
            column: 82
          },
          end: {
            line: 309,
            column: 5
          }
        },
        line: 299
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 304,
            column: 70
          },
          end: {
            line: 304,
            column: 71
          }
        },
        loc: {
          start: {
            line: 304,
            column: 79
          },
          end: {
            line: 306,
            column: 11
          }
        },
        line: 304
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 312,
            column: 23
          },
          end: {
            line: 312,
            column: 24
          }
        },
        loc: {
          start: {
            line: 312,
            column: 40
          },
          end: {
            line: 318,
            column: 3
          }
        },
        line: 312
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 320,
            column: 33
          },
          end: {
            line: 320,
            column: 34
          }
        },
        loc: {
          start: {
            line: 320,
            column: 45
          },
          end: {
            line: 445,
            column: 3
          }
        },
        line: 320
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 325,
            column: 23
          },
          end: {
            line: 325,
            column: 24
          }
        },
        loc: {
          start: {
            line: 325,
            column: 31
          },
          end: {
            line: 444,
            column: 5
          }
        },
        line: 325
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 447,
            column: 32
          },
          end: {
            line: 447,
            column: 33
          }
        },
        loc: {
          start: {
            line: 447,
            column: 44
          },
          end: {
            line: 534,
            column: 3
          }
        },
        line: 447
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 456,
            column: 7
          },
          end: {
            line: 456,
            column: 8
          }
        },
        loc: {
          start: {
            line: 456,
            column: 15
          },
          end: {
            line: 533,
            column: 5
          }
        },
        line: 456
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 457,
            column: 23
          },
          end: {
            line: 457,
            column: 24
          }
        },
        loc: {
          start: {
            line: 457,
            column: 43
          },
          end: {
            line: 459,
            column: 7
          }
        },
        line: 457
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 461,
            column: 22
          },
          end: {
            line: 461,
            column: 23
          }
        },
        loc: {
          start: {
            line: 461,
            column: 31
          },
          end: {
            line: 468,
            column: 7
          }
        },
        line: 461
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 496,
            column: 33
          },
          end: {
            line: 496,
            column: 34
          }
        },
        loc: {
          start: {
            line: 496,
            column: 42
          },
          end: {
            line: 502,
            column: 13
          }
        },
        line: 496
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 507,
            column: 33
          },
          end: {
            line: 507,
            column: 34
          }
        },
        loc: {
          start: {
            line: 507,
            column: 42
          },
          end: {
            line: 513,
            column: 13
          }
        },
        line: 507
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 536,
            column: 19
          },
          end: {
            line: 536,
            column: 20
          }
        },
        loc: {
          start: {
            line: 536,
            column: 25
          },
          end: {
            line: 563,
            column: 3
          }
        },
        line: 536
      },
      '35': {
        name: '(anonymous_35)',
        decl: {
          start: {
            line: 550,
            column: 26
          },
          end: {
            line: 550,
            column: 27
          }
        },
        loc: {
          start: {
            line: 550,
            column: 41
          },
          end: {
            line: 561,
            column: 5
          }
        },
        line: 550
      },
      '36': {
        name: '(anonymous_36)',
        decl: {
          start: {
            line: 564,
            column: 24
          },
          end: {
            line: 564,
            column: 25
          }
        },
        loc: {
          start: {
            line: 564,
            column: 47
          },
          end: {
            line: 596,
            column: 3
          }
        },
        line: 564
      },
      '37': {
        name: '(anonymous_37)',
        decl: {
          start: {
            line: 589,
            column: 16
          },
          end: {
            line: 589,
            column: 17
          }
        },
        loc: {
          start: {
            line: 589,
            column: 27
          },
          end: {
            line: 592,
            column: 5
          }
        },
        line: 589
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 598,
            column: 25
          },
          end: {
            line: 598,
            column: 26
          }
        },
        loc: {
          start: {
            line: 598,
            column: 31
          },
          end: {
            line: 689,
            column: 3
          }
        },
        line: 598
      },
      '39': {
        name: '(anonymous_39)',
        decl: {
          start: {
            line: 654,
            column: 66
          },
          end: {
            line: 654,
            column: 67
          }
        },
        loc: {
          start: {
            line: 654,
            column: 82
          },
          end: {
            line: 669,
            column: 5
          }
        },
        line: 654
      },
      '40': {
        name: '(anonymous_40)',
        decl: {
          start: {
            line: 691,
            column: 30
          },
          end: {
            line: 691,
            column: 31
          }
        },
        loc: {
          start: {
            line: 691,
            column: 42
          },
          end: {
            line: 736,
            column: 3
          }
        },
        line: 691
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 705,
            column: 7
          },
          end: {
            line: 705,
            column: 8
          }
        },
        loc: {
          start: {
            line: 705,
            column: 15
          },
          end: {
            line: 735,
            column: 5
          }
        },
        line: 705
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 725,
            column: 51
          },
          end: {
            line: 725,
            column: 52
          }
        },
        loc: {
          start: {
            line: 725,
            column: 65
          },
          end: {
            line: 733,
            column: 9
          }
        },
        line: 725
      },
      '43': {
        name: '(anonymous_43)',
        decl: {
          start: {
            line: 737,
            column: 39
          },
          end: {
            line: 737,
            column: 40
          }
        },
        loc: {
          start: {
            line: 737,
            column: 45
          },
          end: {
            line: 740,
            column: 3
          }
        },
        line: 737
      },
      '44': {
        name: '(anonymous_44)',
        decl: {
          start: {
            line: 739,
            column: 61
          },
          end: {
            line: 739,
            column: 62
          }
        },
        loc: {
          start: {
            line: 739,
            column: 71
          },
          end: {
            line: 739,
            column: 94
          }
        },
        line: 739
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 744,
            column: 26
          },
          end: {
            line: 744,
            column: 27
          }
        },
        loc: {
          start: {
            line: 744,
            column: 38
          },
          end: {
            line: 752,
            column: 3
          }
        },
        line: 744
      },
      '46': {
        name: '(anonymous_46)',
        decl: {
          start: {
            line: 746,
            column: 47
          },
          end: {
            line: 746,
            column: 48
          }
        },
        loc: {
          start: {
            line: 746,
            column: 56
          },
          end: {
            line: 748,
            column: 7
          }
        },
        line: 746
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 755,
            column: 56
          },
          end: {
            line: 755,
            column: 57
          }
        },
        loc: {
          start: {
            line: 755,
            column: 64
          },
          end: {
            line: 766,
            column: 3
          }
        },
        line: 755
      },
      '48': {
        name: '(anonymous_48)',
        decl: {
          start: {
            line: 762,
            column: 27
          },
          end: {
            line: 762,
            column: 28
          }
        },
        loc: {
          start: {
            line: 762,
            column: 40
          },
          end: {
            line: 762,
            column: 69
          }
        },
        line: 762
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 32,
            column: 14
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 14
          }
        }, {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 38,
            column: 14
          }
        }, {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 41,
            column: 14
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 14
          }
        }, {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 47,
            column: 14
          }
        }],
        line: 29
      },
      '1': {
        loc: {
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 83,
            column: 6
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 53,
            column: 24
          },
          end: {
            line: 68,
            column: 6
          }
        }, {
          start: {
            line: 68,
            column: 9
          },
          end: {
            line: 83,
            column: 6
          }
        }],
        line: 53
      },
      '2': {
        loc: {
          start: {
            line: 84,
            column: 13
          },
          end: {
            line: 84,
            column: 45
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 84,
            column: 39
          },
          end: {
            line: 84,
            column: 41
          }
        }, {
          start: {
            line: 84,
            column: 44
          },
          end: {
            line: 84,
            column: 45
          }
        }],
        line: 84
      },
      '3': {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }],
        line: 93
      },
      '4': {
        loc: {
          start: {
            line: 96,
            column: 11
          },
          end: {
            line: 96,
            column: 67
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 96,
            column: 23
          },
          end: {
            line: 96,
            column: 43
          }
        }, {
          start: {
            line: 96,
            column: 46
          },
          end: {
            line: 96,
            column: 67
          }
        }],
        line: 96
      },
      '5': {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }],
        line: 100
      },
      '6': {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }],
        line: 103
      },
      '7': {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        }, {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        }],
        line: 109
      },
      '8': {
        loc: {
          start: {
            line: 129,
            column: 12
          },
          end: {
            line: 129,
            column: 93
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 129,
            column: 46
          },
          end: {
            line: 129,
            column: 53
          }
        }, {
          start: {
            line: 129,
            column: 57
          },
          end: {
            line: 129,
            column: 92
          }
        }],
        line: 129
      },
      '9': {
        loc: {
          start: {
            line: 130,
            column: 13
          },
          end: {
            line: 130,
            column: 52
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 130,
            column: 47
          },
          end: {
            line: 130,
            column: 48
          }
        }, {
          start: {
            line: 130,
            column: 51
          },
          end: {
            line: 130,
            column: 52
          }
        }],
        line: 130
      },
      '10': {
        loc: {
          start: {
            line: 135,
            column: 17
          },
          end: {
            line: 135,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 135,
            column: 41
          },
          end: {
            line: 135,
            column: 42
          }
        }, {
          start: {
            line: 135,
            column: 45
          },
          end: {
            line: 135,
            column: 47
          }
        }],
        line: 135
      },
      '11': {
        loc: {
          start: {
            line: 141,
            column: 10
          },
          end: {
            line: 143,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 141,
            column: 10
          },
          end: {
            line: 143,
            column: 11
          }
        }, {
          start: {
            line: 141,
            column: 10
          },
          end: {
            line: 143,
            column: 11
          }
        }],
        line: 141
      },
      '12': {
        loc: {
          start: {
            line: 174,
            column: 16
          },
          end: {
            line: 176,
            column: 17
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 174,
            column: 16
          },
          end: {
            line: 176,
            column: 17
          }
        }, {
          start: {
            line: 174,
            column: 16
          },
          end: {
            line: 176,
            column: 17
          }
        }],
        line: 174
      },
      '13': {
        loc: {
          start: {
            line: 185,
            column: 16
          },
          end: {
            line: 187,
            column: 17
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 185,
            column: 16
          },
          end: {
            line: 187,
            column: 17
          }
        }, {
          start: {
            line: 185,
            column: 16
          },
          end: {
            line: 187,
            column: 17
          }
        }],
        line: 185
      },
      '14': {
        loc: {
          start: {
            line: 215,
            column: 17
          },
          end: {
            line: 215,
            column: 33
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 215,
            column: 28
          },
          end: {
            line: 215,
            column: 29
          }
        }, {
          start: {
            line: 215,
            column: 32
          },
          end: {
            line: 215,
            column: 33
          }
        }],
        line: 215
      },
      '15': {
        loc: {
          start: {
            line: 218,
            column: 21
          },
          end: {
            line: 218,
            column: 39
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 218,
            column: 32
          },
          end: {
            line: 218,
            column: 35
          }
        }, {
          start: {
            line: 218,
            column: 38
          },
          end: {
            line: 218,
            column: 39
          }
        }],
        line: 218
      },
      '16': {
        loc: {
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }],
        line: 232
      },
      '17': {
        loc: {
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 232,
            column: 49
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 232,
            column: 29
          }
        }, {
          start: {
            line: 232,
            column: 33
          },
          end: {
            line: 232,
            column: 49
          }
        }],
        line: 232
      },
      '18': {
        loc: {
          start: {
            line: 235,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 235,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        }, {
          start: {
            line: 235,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        }],
        line: 235
      },
      '19': {
        loc: {
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 241,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 241,
            column: 5
          }
        }, {
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 241,
            column: 5
          }
        }],
        line: 239
      },
      '20': {
        loc: {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 245,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 245,
            column: 5
          }
        }, {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 245,
            column: 5
          }
        }],
        line: 243
      },
      '21': {
        loc: {
          start: {
            line: 257,
            column: 10
          },
          end: {
            line: 257,
            column: 56
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 257,
            column: 44
          },
          end: {
            line: 257,
            column: 46
          }
        }, {
          start: {
            line: 257,
            column: 49
          },
          end: {
            line: 257,
            column: 56
          }
        }],
        line: 257
      },
      '22': {
        loc: {
          start: {
            line: 259,
            column: 11
          },
          end: {
            line: 259,
            column: 50
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 259,
            column: 45
          },
          end: {
            line: 259,
            column: 46
          }
        }, {
          start: {
            line: 259,
            column: 49
          },
          end: {
            line: 259,
            column: 50
          }
        }],
        line: 259
      },
      '23': {
        loc: {
          start: {
            line: 260,
            column: 12
          },
          end: {
            line: 260,
            column: 93
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 260,
            column: 46
          },
          end: {
            line: 260,
            column: 53
          }
        }, {
          start: {
            line: 260,
            column: 57
          },
          end: {
            line: 260,
            column: 92
          }
        }],
        line: 260
      },
      '24': {
        loc: {
          start: {
            line: 264,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 264,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        }, {
          start: {
            line: 264,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        }],
        line: 264
      },
      '25': {
        loc: {
          start: {
            line: 267,
            column: 57
          },
          end: {
            line: 267,
            column: 69
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 267,
            column: 57
          },
          end: {
            line: 267,
            column: 63
          }
        }, {
          start: {
            line: 267,
            column: 67
          },
          end: {
            line: 267,
            column: 69
          }
        }],
        line: 267
      },
      '26': {
        loc: {
          start: {
            line: 268,
            column: 6
          },
          end: {
            line: 270,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 268,
            column: 6
          },
          end: {
            line: 270,
            column: 7
          }
        }, {
          start: {
            line: 268,
            column: 6
          },
          end: {
            line: 270,
            column: 7
          }
        }],
        line: 268
      },
      '27': {
        loc: {
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 283,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 283,
            column: 5
          }
        }, {
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 283,
            column: 5
          }
        }],
        line: 275
      },
      '28': {
        loc: {
          start: {
            line: 300,
            column: 6
          },
          end: {
            line: 308,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 300,
            column: 6
          },
          end: {
            line: 308,
            column: 7
          }
        }, {
          start: {
            line: 300,
            column: 6
          },
          end: {
            line: 308,
            column: 7
          }
        }],
        line: 300
      },
      '29': {
        loc: {
          start: {
            line: 303,
            column: 8
          },
          end: {
            line: 307,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 303,
            column: 8
          },
          end: {
            line: 307,
            column: 9
          }
        }, {
          start: {
            line: 303,
            column: 8
          },
          end: {
            line: 307,
            column: 9
          }
        }],
        line: 303
      },
      '30': {
        loc: {
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 324,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 324,
            column: 5
          }
        }, {
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 324,
            column: 5
          }
        }],
        line: 322
      },
      '31': {
        loc: {
          start: {
            line: 332,
            column: 6
          },
          end: {
            line: 368,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 332,
            column: 6
          },
          end: {
            line: 368,
            column: 7
          }
        }, {
          start: {
            line: 332,
            column: 6
          },
          end: {
            line: 368,
            column: 7
          }
        }],
        line: 332
      },
      '32': {
        loc: {
          start: {
            line: 349,
            column: 82
          },
          end: {
            line: 349,
            column: 139
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 349,
            column: 112
          },
          end: {
            line: 349,
            column: 115
          }
        }, {
          start: {
            line: 349,
            column: 118
          },
          end: {
            line: 349,
            column: 139
          }
        }],
        line: 349
      },
      '33': {
        loc: {
          start: {
            line: 354,
            column: 24
          },
          end: {
            line: 354,
            column: 81
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 354,
            column: 54
          },
          end: {
            line: 354,
            column: 57
          }
        }, {
          start: {
            line: 354,
            column: 60
          },
          end: {
            line: 354,
            column: 81
          }
        }],
        line: 354
      },
      '34': {
        loc: {
          start: {
            line: 357,
            column: 33
          },
          end: {
            line: 357,
            column: 90
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 357,
            column: 63
          },
          end: {
            line: 357,
            column: 66
          }
        }, {
          start: {
            line: 357,
            column: 69
          },
          end: {
            line: 357,
            column: 90
          }
        }],
        line: 357
      },
      '35': {
        loc: {
          start: {
            line: 359,
            column: 37
          },
          end: {
            line: 359,
            column: 73
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 359,
            column: 68
          },
          end: {
            line: 359,
            column: 69
          }
        }, {
          start: {
            line: 359,
            column: 72
          },
          end: {
            line: 359,
            column: 73
          }
        }],
        line: 359
      },
      '36': {
        loc: {
          start: {
            line: 370,
            column: 6
          },
          end: {
            line: 399,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 370,
            column: 6
          },
          end: {
            line: 399,
            column: 7
          }
        }, {
          start: {
            line: 370,
            column: 6
          },
          end: {
            line: 399,
            column: 7
          }
        }],
        line: 370
      },
      '37': {
        loc: {
          start: {
            line: 384,
            column: 81
          },
          end: {
            line: 384,
            column: 138
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 384,
            column: 111
          },
          end: {
            line: 384,
            column: 114
          }
        }, {
          start: {
            line: 384,
            column: 117
          },
          end: {
            line: 384,
            column: 138
          }
        }],
        line: 384
      },
      '38': {
        loc: {
          start: {
            line: 389,
            column: 22
          },
          end: {
            line: 389,
            column: 79
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 389,
            column: 52
          },
          end: {
            line: 389,
            column: 55
          }
        }, {
          start: {
            line: 389,
            column: 58
          },
          end: {
            line: 389,
            column: 79
          }
        }],
        line: 389
      },
      '39': {
        loc: {
          start: {
            line: 392,
            column: 31
          },
          end: {
            line: 392,
            column: 88
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 392,
            column: 61
          },
          end: {
            line: 392,
            column: 64
          }
        }, {
          start: {
            line: 392,
            column: 67
          },
          end: {
            line: 392,
            column: 88
          }
        }],
        line: 392
      },
      '40': {
        loc: {
          start: {
            line: 394,
            column: 35
          },
          end: {
            line: 394,
            column: 71
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 394,
            column: 66
          },
          end: {
            line: 394,
            column: 67
          }
        }, {
          start: {
            line: 394,
            column: 70
          },
          end: {
            line: 394,
            column: 71
          }
        }],
        line: 394
      },
      '41': {
        loc: {
          start: {
            line: 401,
            column: 6
          },
          end: {
            line: 443,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 401,
            column: 6
          },
          end: {
            line: 443,
            column: 7
          }
        }, {
          start: {
            line: 401,
            column: 6
          },
          end: {
            line: 443,
            column: 7
          }
        }],
        line: 401
      },
      '42': {
        loc: {
          start: {
            line: 401,
            column: 10
          },
          end: {
            line: 401,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 401,
            column: 10
          },
          end: {
            line: 401,
            column: 31
          }
        }, {
          start: {
            line: 401,
            column: 35
          },
          end: {
            line: 401,
            column: 56
          }
        }],
        line: 401
      },
      '43': {
        loc: {
          start: {
            line: 406,
            column: 8
          },
          end: {
            line: 442,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 406,
            column: 8
          },
          end: {
            line: 442,
            column: 9
          }
        }, {
          start: {
            line: 406,
            column: 8
          },
          end: {
            line: 442,
            column: 9
          }
        }],
        line: 406
      },
      '44': {
        loc: {
          start: {
            line: 408,
            column: 10
          },
          end: {
            line: 410,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 408,
            column: 10
          },
          end: {
            line: 410,
            column: 11
          }
        }, {
          start: {
            line: 408,
            column: 10
          },
          end: {
            line: 410,
            column: 11
          }
        }],
        line: 408
      },
      '45': {
        loc: {
          start: {
            line: 411,
            column: 10
          },
          end: {
            line: 413,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 411,
            column: 10
          },
          end: {
            line: 413,
            column: 11
          }
        }, {
          start: {
            line: 411,
            column: 10
          },
          end: {
            line: 413,
            column: 11
          }
        }],
        line: 411
      },
      '46': {
        loc: {
          start: {
            line: 437,
            column: 37
          },
          end: {
            line: 437,
            column: 58
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 437,
            column: 53
          },
          end: {
            line: 437,
            column: 54
          }
        }, {
          start: {
            line: 437,
            column: 57
          },
          end: {
            line: 437,
            column: 58
          }
        }],
        line: 437
      },
      '47': {
        loc: {
          start: {
            line: 448,
            column: 4
          },
          end: {
            line: 450,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 448,
            column: 4
          },
          end: {
            line: 450,
            column: 5
          }
        }, {
          start: {
            line: 448,
            column: 4
          },
          end: {
            line: 450,
            column: 5
          }
        }],
        line: 448
      },
      '48': {
        loc: {
          start: {
            line: 454,
            column: 10
          },
          end: {
            line: 454,
            column: 91
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 454,
            column: 44
          },
          end: {
            line: 454,
            column: 51
          }
        }, {
          start: {
            line: 454,
            column: 55
          },
          end: {
            line: 454,
            column: 90
          }
        }],
        line: 454
      },
      '49': {
        loc: {
          start: {
            line: 455,
            column: 11
          },
          end: {
            line: 455,
            column: 50
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 455,
            column: 45
          },
          end: {
            line: 455,
            column: 46
          }
        }, {
          start: {
            line: 455,
            column: 49
          },
          end: {
            line: 455,
            column: 50
          }
        }],
        line: 455
      },
      '50': {
        loc: {
          start: {
            line: 458,
            column: 15
          },
          end: {
            line: 458,
            column: 45
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 458,
            column: 39
          },
          end: {
            line: 458,
            column: 40
          }
        }, {
          start: {
            line: 458,
            column: 43
          },
          end: {
            line: 458,
            column: 45
          }
        }],
        line: 458
      },
      '51': {
        loc: {
          start: {
            line: 464,
            column: 8
          },
          end: {
            line: 466,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 464,
            column: 8
          },
          end: {
            line: 466,
            column: 9
          }
        }, {
          start: {
            line: 464,
            column: 8
          },
          end: {
            line: 466,
            column: 9
          }
        }],
        line: 464
      },
      '52': {
        loc: {
          start: {
            line: 498,
            column: 14
          },
          end: {
            line: 500,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 498,
            column: 14
          },
          end: {
            line: 500,
            column: 15
          }
        }, {
          start: {
            line: 498,
            column: 14
          },
          end: {
            line: 500,
            column: 15
          }
        }],
        line: 498
      },
      '53': {
        loc: {
          start: {
            line: 509,
            column: 14
          },
          end: {
            line: 511,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 509,
            column: 14
          },
          end: {
            line: 511,
            column: 15
          }
        }, {
          start: {
            line: 509,
            column: 14
          },
          end: {
            line: 511,
            column: 15
          }
        }],
        line: 509
      },
      '54': {
        loc: {
          start: {
            line: 556,
            column: 30
          },
          end: {
            line: 556,
            column: 78
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 556,
            column: 49
          },
          end: {
            line: 556,
            column: 74
          }
        }, {
          start: {
            line: 556,
            column: 77
          },
          end: {
            line: 556,
            column: 78
          }
        }],
        line: 556
      },
      '55': {
        loc: {
          start: {
            line: 557,
            column: 13
          },
          end: {
            line: 557,
            column: 93
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 557,
            column: 32
          },
          end: {
            line: 557,
            column: 86
          }
        }, {
          start: {
            line: 557,
            column: 89
          },
          end: {
            line: 557,
            column: 93
          }
        }],
        line: 557
      },
      '56': {
        loc: {
          start: {
            line: 558,
            column: 11
          },
          end: {
            line: 558,
            column: 114
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 558,
            column: 28
          },
          end: {
            line: 558,
            column: 109
          }
        }, {
          start: {
            line: 558,
            column: 112
          },
          end: {
            line: 558,
            column: 114
          }
        }],
        line: 558
      },
      '57': {
        loc: {
          start: {
            line: 603,
            column: 6
          },
          end: {
            line: 605,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 603,
            column: 6
          },
          end: {
            line: 605,
            column: 7
          }
        }, {
          start: {
            line: 603,
            column: 6
          },
          end: {
            line: 605,
            column: 7
          }
        }],
        line: 603
      },
      '58': {
        loc: {
          start: {
            line: 660,
            column: 8
          },
          end: {
            line: 664,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 660,
            column: 8
          },
          end: {
            line: 664,
            column: 9
          }
        }, {
          start: {
            line: 660,
            column: 8
          },
          end: {
            line: 664,
            column: 9
          }
        }],
        line: 660
      },
      '59': {
        loc: {
          start: {
            line: 666,
            column: 6
          },
          end: {
            line: 668,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 666,
            column: 6
          },
          end: {
            line: 668,
            column: 7
          }
        }, {
          start: {
            line: 666,
            column: 6
          },
          end: {
            line: 668,
            column: 7
          }
        }],
        line: 666
      },
      '60': {
        loc: {
          start: {
            line: 692,
            column: 4
          },
          end: {
            line: 694,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 692,
            column: 4
          },
          end: {
            line: 694,
            column: 5
          }
        }, {
          start: {
            line: 692,
            column: 4
          },
          end: {
            line: 694,
            column: 5
          }
        }],
        line: 692
      },
      '61': {
        loc: {
          start: {
            line: 697,
            column: 4
          },
          end: {
            line: 699,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 697,
            column: 4
          },
          end: {
            line: 699,
            column: 5
          }
        }, {
          start: {
            line: 697,
            column: 4
          },
          end: {
            line: 699,
            column: 5
          }
        }],
        line: 697
      },
      '62': {
        loc: {
          start: {
            line: 703,
            column: 14
          },
          end: {
            line: 703,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 703,
            column: 14
          },
          end: {
            line: 703,
            column: 32
          }
        }, {
          start: {
            line: 703,
            column: 36
          },
          end: {
            line: 703,
            column: 50
          }
        }],
        line: 703
      },
      '63': {
        loc: {
          start: {
            line: 708,
            column: 6
          },
          end: {
            line: 718,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 708,
            column: 6
          },
          end: {
            line: 718,
            column: 7
          }
        }, {
          start: {
            line: 708,
            column: 6
          },
          end: {
            line: 718,
            column: 7
          }
        }],
        line: 708
      },
      '64': {
        loc: {
          start: {
            line: 708,
            column: 10
          },
          end: {
            line: 708,
            column: 115
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 708,
            column: 10
          },
          end: {
            line: 708,
            column: 34
          }
        }, {
          start: {
            line: 708,
            column: 38
          },
          end: {
            line: 708,
            column: 73
          }
        }, {
          start: {
            line: 708,
            column: 77
          },
          end: {
            line: 708,
            column: 115
          }
        }],
        line: 708
      },
      '65': {
        loc: {
          start: {
            line: 713,
            column: 13
          },
          end: {
            line: 718,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 713,
            column: 13
          },
          end: {
            line: 718,
            column: 7
          }
        }, {
          start: {
            line: 713,
            column: 13
          },
          end: {
            line: 718,
            column: 7
          }
        }],
        line: 713
      },
      '66': {
        loc: {
          start: {
            line: 720,
            column: 6
          },
          end: {
            line: 734,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 720,
            column: 6
          },
          end: {
            line: 734,
            column: 7
          }
        }, {
          start: {
            line: 720,
            column: 6
          },
          end: {
            line: 734,
            column: 7
          }
        }],
        line: 720
      },
      '67': {
        loc: {
          start: {
            line: 730,
            column: 10
          },
          end: {
            line: 732,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 730,
            column: 10
          },
          end: {
            line: 732,
            column: 11
          }
        }, {
          start: {
            line: 730,
            column: 10
          },
          end: {
            line: 732,
            column: 11
          }
        }],
        line: 730
      },
      '68': {
        loc: {
          start: {
            line: 730,
            column: 14
          },
          end: {
            line: 730,
            column: 64
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 730,
            column: 14
          },
          end: {
            line: 730,
            column: 40
          }
        }, {
          start: {
            line: 730,
            column: 44
          },
          end: {
            line: 730,
            column: 64
          }
        }],
        line: 730
      },
      '69': {
        loc: {
          start: {
            line: 738,
            column: 23
          },
          end: {
            line: 738,
            column: 92
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 738,
            column: 23
          },
          end: {
            line: 738,
            column: 87
          }
        }, {
          start: {
            line: 738,
            column: 91
          },
          end: {
            line: 738,
            column: 92
          }
        }],
        line: 738
      },
      '70': {
        loc: {
          start: {
            line: 739,
            column: 25
          },
          end: {
            line: 739,
            column: 133
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 739,
            column: 25
          },
          end: {
            line: 739,
            column: 96
          }
        }, {
          start: {
            line: 739,
            column: 100
          },
          end: {
            line: 739,
            column: 133
          }
        }],
        line: 739
      },
      '71': {
        loc: {
          start: {
            line: 745,
            column: 4
          },
          end: {
            line: 751,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 745,
            column: 4
          },
          end: {
            line: 751,
            column: 5
          }
        }, {
          start: {
            line: 745,
            column: 4
          },
          end: {
            line: 751,
            column: 5
          }
        }],
        line: 745
      },
      '72': {
        loc: {
          start: {
            line: 762,
            column: 6
          },
          end: {
            line: 763,
            column: 24
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 762,
            column: 6
          },
          end: {
            line: 762,
            column: 71
          }
        }, {
          start: {
            line: 763,
            column: 6
          },
          end: {
            line: 763,
            column: 24
          }
        }],
        line: 762
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0,
      '256': 0,
      '257': 0,
      '258': 0,
      '259': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0
    },
    b: {
      '0': [0, 0, 0, 0, 0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0, 0],
      '61': [0, 0],
      '62': [0, 0],
      '63': [0, 0],
      '64': [0, 0, 0],
      '65': [0, 0],
      '66': [0, 0],
      '67': [0, 0],
      '68': [0, 0],
      '69': [0, 0],
      '70': [0, 0],
      '71': [0, 0],
      '72': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

cov_172wm16s2f.s[0]++;
angular.module('app').controller('activityDashboardGlobalCtrl', function ($scope, $rootScope, $CRUDService, $deltaPeriode, $filter, $deltaActor, $stateParams, $deltaGeoLevel, $http, $deltadate, $translate, $log) {
  cov_172wm16s2f.f[0]++;

  var PATH = (cov_172wm16s2f.s[1]++, 'Activites');
  var PATH_LOCALITY = (cov_172wm16s2f.s[2]++, 'Localites');
  var PATH_CL = (cov_172wm16s2f.s[3]++, 'CadreLogique');
  var PATH_DN = (cov_172wm16s2f.s[4]++, 'DernierNiveau');

  var ACTIVITY_DASHBOARD_PROJECT_GLOBAL_ACTIVITY = (cov_172wm16s2f.s[5]++, 'ACTIVITY_DASHBOARD_PROJECT_GLOBAL_ACTIVITY' + $rootScope.currentProject.project.id);

  var ACTIVITY_DASHBOARD_PROJECT_GLOBAL_GEO_PLAN = (cov_172wm16s2f.s[6]++, 'ACTIVITY_DASHBOARD_PROJECT_GLOBAL_GEO_PLAN' + $rootScope.currentProject.project.id);

  cov_172wm16s2f.s[7]++;

  $scope.height = $('body').height() - 548 + 'px';
  cov_172wm16s2f.s[8]++;

  $scope.choise = {
    displayIndex: 0,
    validatedData: false,
    hasValidationWorkflow: false
  };
  cov_172wm16s2f.s[9]++;
  $scope.mapData = {};
  cov_172wm16s2f.s[10]++;
  $scope.mapCenter = null;

  cov_172wm16s2f.s[11]++;
  $scope.canClose = $stateParams.view_item == 1;

  cov_172wm16s2f.s[12]++;
  var getMapUrl = function getMapUrl(value) {
    cov_172wm16s2f.f[1]++;

    var mapstr = (cov_172wm16s2f.s[13]++, 'https://api.mapbox.com/styles/v1/bksb/cjnem4vy029oz2sphj8jvnp9a/tiles/256/{z}/{x}/{y}');
    cov_172wm16s2f.s[14]++;

    switch (value) {
      case 0:
        cov_172wm16s2f.b[0][0]++;
        cov_172wm16s2f.s[15]++;

        mapstr = 'https://api.mapbox.com/styles/v1/bksb/cjnem4vy029oz2sphj8jvnp9a/tiles/256/{z}/{x}/{y}';
        cov_172wm16s2f.s[16]++;
        break;
      case 1:
        cov_172wm16s2f.b[0][1]++;
        cov_172wm16s2f.s[17]++;

        mapstr = 'https://api.mapbox.com/styles/v1/bksb/cjvs9jqk60fr91cscf0w98zth/tiles/256/{z}/{x}/{y}@2x';
        cov_172wm16s2f.s[18]++;
        break;
      case 2:
        cov_172wm16s2f.b[0][2]++;
        cov_172wm16s2f.s[19]++;

        mapstr = 'https://api.mapbox.com/styles/v1/bksb/cjvsbh28818ic1cmqcfaz1is2/tiles/256/{z}/{x}/{y}@2x';
        cov_172wm16s2f.s[20]++;
        break;
      case 3:
        cov_172wm16s2f.b[0][3]++;
        cov_172wm16s2f.s[21]++;

        mapstr = 'https://api.mapbox.com/styles/v1/bksb/cjvsbjkcx0mkz1cp3ot9cdfnk/tiles/256/{z}/{x}/{y}@2x';
        cov_172wm16s2f.s[22]++;
        break;
      case 4:
        cov_172wm16s2f.b[0][4]++;
        cov_172wm16s2f.s[23]++;

        mapstr = 'https://api.mapbox.com/styles/v1/bksb/ck0wcr1og05gz1cq7ik9y0ct5/tiles/256/{z}/{x}/{y}@2x';
        cov_172wm16s2f.s[24]++;
        break;
      default:
        cov_172wm16s2f.b[0][5]++;
        cov_172wm16s2f.s[25]++;

        mapstr = 'https://api.mapbox.com/styles/v1/bksb/cj8x1v3iv05pz2rrtc9ps1tui/tiles/256/{z}/{x}/{y}';
        cov_172wm16s2f.s[26]++;
        break;
    }
    cov_172wm16s2f.s[27]++;
    return mapstr + '?access_token=pk.eyJ1IjoiYmtzYiIsImEiOiJjaXQ5ZHlpM2gwMDJvMnNwaDAxZXFsbndrIn0.0W3tcj-HtlRSCJDcuxNRew';
  };

  cov_172wm16s2f.s[28]++;
  var getColors = function getColors(type) {
    cov_172wm16s2f.f[2]++;
    cov_172wm16s2f.s[29]++;

    return (type == 1 ? (cov_172wm16s2f.b[1][0]++, [{
      valueMax: 20,
      color: 'rgba(242,0,5,0.95)'
    }, {
      valueMax: 40,
      color: 'rgba(242,112,0,0.95)'
    }, {
      valueMax: 60,
      color: 'rgba(203,242,0,0.95)'
    }, {
      valueMax: 80,
      color: 'rgba(96,242,0,0.95)'
    }, {
      valueMax: 100,
      color: 'rgba(0,242,96,0.95)'
    }]) : (cov_172wm16s2f.b[1][1]++, [{
      valueMax: 100,
      color: 'rgba(242,0,5,0.95)'
    }, {
      valueMax: 80,
      color: 'rgba(242,112,0,0.95)'
    }, {
      valueMax: 60,
      color: 'rgba(203,242,0,0.95)'
    }, {
      valueMax: 40,
      color: 'rgba(96,242,0,0.95)'
    }, {
      valueMax: 20,
      color: 'rgba(0,242,96,0.95)'
    }])).sort(function (a, b) {
      cov_172wm16s2f.f[3]++;
      cov_172wm16s2f.s[30]++;

      return a.valueMax < b.valueMax ? (cov_172wm16s2f.b[2][0]++, -1) : (cov_172wm16s2f.b[2][1]++, 1);
    });
  };

  cov_172wm16s2f.s[31]++;
  var getColor = function getColor(value, type) {
    cov_172wm16s2f.f[4]++;

    var colors = (cov_172wm16s2f.s[32]++, getColors(type).filter(function (val) {
      cov_172wm16s2f.f[5]++;
      cov_172wm16s2f.s[33]++;

      return val.valueMax > value;
    }));

    cov_172wm16s2f.s[34]++;
    if (colors.length > 0) {
      cov_172wm16s2f.b[3][0]++;
      cov_172wm16s2f.s[35]++;

      return colors[0].color;
    } else {
      cov_172wm16s2f.b[3][1]++;
    }
    cov_172wm16s2f.s[36]++;
    return type != 1 ? (cov_172wm16s2f.b[4][0]++, 'rgba(242,0,5,0.95)') : (cov_172wm16s2f.b[4][1]++, 'rgba(0,242,96,0.95)');
  };

  cov_172wm16s2f.s[37]++;
  var customlayers = function customlayers(layerId, value) {
    cov_172wm16s2f.f[6]++;
    cov_172wm16s2f.s[38]++;

    if (!layerId) {
      cov_172wm16s2f.b[5][0]++;
      cov_172wm16s2f.s[39]++;

      return;
    } else {
      cov_172wm16s2f.b[5][1]++;
    }
    cov_172wm16s2f.s[40]++;
    if (!$scope.layersGroup.hasLayer(layerId)) {
      cov_172wm16s2f.b[6][0]++;
      cov_172wm16s2f.s[41]++;

      return;
    } else {
      cov_172wm16s2f.b[6][1]++;
    }

    var layer = (cov_172wm16s2f.s[42]++, $scope.layersGroup.getLayer(layerId));
    cov_172wm16s2f.s[43]++;
    layer.off();
    cov_172wm16s2f.s[44]++;
    if (!value) {
      cov_172wm16s2f.b[7][0]++;
      cov_172wm16s2f.s[45]++;

      layer.setStyle(function () {
        cov_172wm16s2f.f[7]++;
        cov_172wm16s2f.s[46]++;

        return {
          fillColor: getColor(0, 1),
          weight: 2,
          opacity: 0,
          color: getColor(0, 1),
          dashArray: '3',
          fillOpacity: 0
        };
      });
      cov_172wm16s2f.s[47]++;
      return;
    } else {
      cov_172wm16s2f.b[7][1]++;
    }
    cov_172wm16s2f.s[48]++;
    layer.on('click', function (a) {
      cov_172wm16s2f.f[8]++;

      var popup = (cov_172wm16s2f.s[49]++, L.popup().setLatLng(a.latlng).setContent('<div><h4 class="text-center">' + $scope.mappingLocatities[layer.options.info.code].DESCRIPTION_L + '</h4></div><div id="chart-popup" style="width: 300px; height: 300px"><div class="spinner-example" > <div class="sk-spinner sk-spinner-wave">  <div class="sk-rect1"></div>  <div class="sk-rect2"></div>   <div class="sk-rect3"></div>  <div class="sk-rect4"></div> <div class="sk-rect5"></div> </div> </div></div>').openOn($scope.layersGroup._map));
      cov_172wm16s2f.s[50]++;
      getInformation({
        get: 'chart_informations',
        a2: $scope.choise.displayIndex == 0 ? (cov_172wm16s2f.b[8][0]++, '0_0_0') : (cov_172wm16s2f.b[8][1]++, $scope.choise.displayIndex + '_1_1'),
        la2: $scope.choise.displayIndex == 0 ? (cov_172wm16s2f.b[9][0]++, 1) : (cov_172wm16s2f.b[9][1]++, 2),
        code_lc: layer.options.info.code
      }, function (data) {
        cov_172wm16s2f.f[9]++;
        cov_172wm16s2f.s[51]++;

        $('#chart-popup').html('');
        cov_172wm16s2f.s[52]++;
        data = data.sort(function (valueA, valueB) {
          cov_172wm16s2f.f[10]++;
          cov_172wm16s2f.s[53]++;

          return valueA.id > valueB.id ? (cov_172wm16s2f.b[10][0]++, 1) : (cov_172wm16s2f.b[10][1]++, -1);
        });

        cov_172wm16s2f.s[54]++;
        data = data.map(function (value) {
          cov_172wm16s2f.f[11]++;

          var ids = (cov_172wm16s2f.s[55]++, value.id.split('_'));
          cov_172wm16s2f.s[56]++;
          value.label = ids[0];
          cov_172wm16s2f.s[57]++;
          if ($scope.choise.displayIndex != 0) {
            cov_172wm16s2f.b[11][0]++;
            cov_172wm16s2f.s[58]++;

            value.label = $deltadate.getLabelPerioddepth(ids[1], ids[2]);
          } else {
            cov_172wm16s2f.b[11][1]++;
          }
          cov_172wm16s2f.s[59]++;
          return value;
        });
        var chart = (cov_172wm16s2f.s[60]++, new ej.charts.Chart({
          primaryXAxis: {
            title: '',
            interval: 1,
            labelIntersectAction: 'Rotate45',
            valueType: 'Category',
            majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
            majorTickLines: { width: 0 }, minorTickLines: { width: 0 }
          },

          primaryYAxis: {
            title: '',
            valueType: 'Double',
            labelFormat: '{value} %'
          },
          chartArea: {
            border: {
              width: 0
            }
          },

          series: [{
            type: 'Column',
            fill: 'rgb(68, 114, 196)',
            dataSource: data.map(function (value) {
              cov_172wm16s2f.f[12]++;

              var d_ = (cov_172wm16s2f.s[61]++, { x: value.label, y: null });
              cov_172wm16s2f.s[62]++;
              if (value.BB) {
                cov_172wm16s2f.b[12][0]++;
                cov_172wm16s2f.s[63]++;

                d_.y = value.TB;
              } else {
                cov_172wm16s2f.b[12][1]++;
              }
              cov_172wm16s2f.s[64]++;
              return d_;
            }),
            xName: 'x', yName: 'y', name: $translate.instant('ANALYSE.FIELDS.BUDGET.T')
          }, {
            fill: 'rgb(237, 125, 49)',
            type: 'Line',
            dataSource: data.map(function (value) {
              cov_172wm16s2f.f[13]++;

              var d_ = (cov_172wm16s2f.s[65]++, { x: value.label, y: null });
              cov_172wm16s2f.s[66]++;
              if (value.TP) {
                cov_172wm16s2f.b[13][0]++;
                cov_172wm16s2f.s[67]++;

                d_.y = value.TP;
              } else {
                cov_172wm16s2f.b[13][1]++;
              }
              cov_172wm16s2f.s[68]++;
              return d_;
            }),
            xName: 'x', yName: 'y', name: $translate.instant('ANALYSE.FIELDS.PHYSIC.T'),
            width: 2,
            marker: {
              visible: true,
              width: 10,
              height: 10
            }
          }],
          width: '300px',
          height: '300px',

          tooltip: {
            enable: true
          }

        }));
        cov_172wm16s2f.s[69]++;
        chart.appendTo('#chart-popup');
      });
    });
    cov_172wm16s2f.s[70]++;
    layer.setStyle(function () {
      cov_172wm16s2f.f[14]++;

      var params = (cov_172wm16s2f.s[71]++, {
        fillColor: getColor(value.TP, 1),
        weight: 2,
        opacity: value.TB ? (cov_172wm16s2f.b[14][0]++, 1) : (cov_172wm16s2f.b[14][1]++, 0),
        color: getColor(value.TP, 1),
        dashArray: '3',
        fillOpacity: value.TP ? (cov_172wm16s2f.b[15][0]++, 0.1) : (cov_172wm16s2f.b[15][1]++, 0)
      });
      cov_172wm16s2f.s[72]++;
      return params;
    });
  };
  cov_172wm16s2f.s[73]++;
  $scope.globalValue = null;
  cov_172wm16s2f.s[74]++;
  $deltaPeriode.addController($scope);
  cov_172wm16s2f.s[75]++;
  $deltaActor.addController($scope);

  cov_172wm16s2f.s[76]++;
  $CRUDService.getAll('DernierNiveau', { get: 'activity_state' }, function (data) {
    cov_172wm16s2f.f[15]++;
    cov_172wm16s2f.s[77]++;

    $scope.stateActivity = data;
  });

  cov_172wm16s2f.s[78]++;
  $scope.getState = function () {
    cov_172wm16s2f.f[16]++;
    cov_172wm16s2f.s[79]++;

    if ((cov_172wm16s2f.b[17][0]++, !$scope.stateActivity) || (cov_172wm16s2f.b[17][1]++, !$scope.activity)) {
      cov_172wm16s2f.b[16][0]++;
      cov_172wm16s2f.s[80]++;

      return '';
    } else {
      cov_172wm16s2f.b[16][1]++;
    }
    cov_172wm16s2f.s[81]++;
    if ($scope.stateActivity.completed[$scope.activity.id]) {
      cov_172wm16s2f.b[18][0]++;
      cov_172wm16s2f.s[82]++;

      return $translate.instant('DASHBOARD.ACTIVITIES_TAB.COMPLETED_ACTIVITIES');
    } else {
      cov_172wm16s2f.b[18][1]++;
    }

    cov_172wm16s2f.s[83]++;
    if ($scope.stateActivity.not_carried_out[$scope.activity.id]) {
      cov_172wm16s2f.b[19][0]++;
      cov_172wm16s2f.s[84]++;

      return $translate.instant('DASHBOARD.ACTIVITIES_TAB.NOT_CARRIED_OUT_ACTIVITIES');
    } else {
      cov_172wm16s2f.b[19][1]++;
    }

    cov_172wm16s2f.s[85]++;
    if ($scope.stateActivity.on_going[$scope.activity.id]) {
      cov_172wm16s2f.b[20][0]++;
      cov_172wm16s2f.s[86]++;

      return $translate.instant('DASHBOARD.ACTIVITIES_TAB.ON_GOING_ACTIVITIES');
    } else {
      cov_172wm16s2f.b[20][1]++;
    }
    cov_172wm16s2f.s[87]++;
    return '';
  };

  cov_172wm16s2f.s[88]++;
  $scope.activity = null;

  cov_172wm16s2f.s[89]++;
  var getInformation = function getInformation(params, processAfter) {
    cov_172wm16s2f.f[17]++;

    var baseParams = (cov_172wm16s2f.s[90]++, {
      get: 'global_informations',
      id: 0,
      a1: $scope.activity.CODE_P,
      a2: $scope.choise.displayIndex == 0 ? (cov_172wm16s2f.b[21][0]++, '') : (cov_172wm16s2f.b[21][1]++, '0_0_0'),
      la1: $scope.activity.level - 1,
      la2: $scope.choise.displayIndex == 0 ? (cov_172wm16s2f.b[22][0]++, 0) : (cov_172wm16s2f.b[22][1]++, 1),
      year: $scope.choise.displayIndex == 0 ? (cov_172wm16s2f.b[23][0]++, '0_0_0') : (cov_172wm16s2f.b[23][1]++, $scope.choise.displayIndex + '_1_1'),
      code: $scope.activity.CODE_CLC
    });
    cov_172wm16s2f.s[91]++;

    if ($scope.choise.validatedData) {
      cov_172wm16s2f.b[24][0]++;
      cov_172wm16s2f.s[92]++;

      baseParams.valid = 1;
    } else {
      cov_172wm16s2f.b[24][1]++;
    }
    cov_172wm16s2f.s[93]++;
    $CRUDService.getAll(PATH, Object.assign(baseParams, (cov_172wm16s2f.b[25][0]++, params) || (cov_172wm16s2f.b[25][1]++, {})), function (data) {
      cov_172wm16s2f.f[18]++;
      cov_172wm16s2f.s[94]++;

      if (processAfter) {
        cov_172wm16s2f.b[26][0]++;
        cov_172wm16s2f.s[95]++;

        processAfter(data);
      } else {
        cov_172wm16s2f.b[26][1]++;
      }
    });
  };

  cov_172wm16s2f.s[96]++;
  $scope.getAllInformations = function (item) {
    cov_172wm16s2f.f[19]++;
    cov_172wm16s2f.s[97]++;

    if (item) {
      cov_172wm16s2f.b[27][0]++;
      cov_172wm16s2f.s[98]++;

      $scope.activity = item;
      cov_172wm16s2f.s[99]++;
      localStorage.setItem(ACTIVITY_DASHBOARD_PROJECT_GLOBAL_ACTIVITY, item.id);
      cov_172wm16s2f.s[100]++;
      $scope.getDetails();
      cov_172wm16s2f.s[101]++;

      $CRUDService.getAll(PATH_DN, { get: 'has_activity_validation_workflow', id_activite: item.id }, function (response) {
        cov_172wm16s2f.f[20]++;
        cov_172wm16s2f.s[102]++;

        $scope.choise.hasValidationWorkflow = response.hasWorkflow;
      });
    } else {
      cov_172wm16s2f.b[27][1]++;
    }
    cov_172wm16s2f.s[103]++;
    $scope.mappingLocatities = null;
    cov_172wm16s2f.s[104]++;
    $scope.getGlobalInformations();
    cov_172wm16s2f.s[105]++;
    $scope.getChartInformations();
    cov_172wm16s2f.s[106]++;
    $scope.getMapInformations();
  };

  cov_172wm16s2f.s[107]++;

  $scope.changeValidatedData = function () {
    cov_172wm16s2f.f[21]++;
    cov_172wm16s2f.s[108]++;

    $scope.getGlobalInformations();
    cov_172wm16s2f.s[109]++;
    $scope.getChartInformations();
    cov_172wm16s2f.s[110]++;
    $scope.getMapInformations();
  };

  cov_172wm16s2f.s[111]++;
  $scope.getDetails = function () {
    cov_172wm16s2f.f[22]++;
    cov_172wm16s2f.s[112]++;

    $scope.dataDetails = null;
    cov_172wm16s2f.s[113]++;
    $CRUDService.getAll(PATH_DN, { get: 'single', id: $scope.activity.id }, function (data) {
      cov_172wm16s2f.f[23]++;
      cov_172wm16s2f.s[114]++;

      if (data.length > 0) {
        cov_172wm16s2f.b[28][0]++;
        cov_172wm16s2f.s[115]++;

        $scope.dataDetails = data[0];

        cov_172wm16s2f.s[116]++;
        if ($scope.dataDetails.IDACTEURS) {
          cov_172wm16s2f.b[29][0]++;
          cov_172wm16s2f.s[117]++;

          $scope.dataDetails.RESPO = $scope.listData_actors_bksb.find(function (actor) {
            cov_172wm16s2f.f[24]++;
            cov_172wm16s2f.s[118]++;

            return actor.id == $scope.dataDetails.IDACTEURS;
          });
        } else {
          cov_172wm16s2f.b[29][1]++;
        }
      } else {
        cov_172wm16s2f.b[28][1]++;
      }
    });
  };

  cov_172wm16s2f.s[119]++;
  $scope.changeLevel = function (level) {
    cov_172wm16s2f.f[25]++;
    cov_172wm16s2f.s[120]++;

    $scope.mapGeoLevel = level;
    cov_172wm16s2f.s[121]++;
    $scope.mappingLocatities = null;

    cov_172wm16s2f.s[122]++;
    localStorage.setItem(ACTIVITY_DASHBOARD_PROJECT_GLOBAL_GEO_PLAN, $scope.mapGeoLevel.id);
    cov_172wm16s2f.s[123]++;
    $scope.getMapInformations();
  };

  cov_172wm16s2f.s[124]++;
  $scope.getGlobalInformations = function () {
    cov_172wm16s2f.f[26]++;
    cov_172wm16s2f.s[125]++;

    $scope.globalValue = null;
    cov_172wm16s2f.s[126]++;
    if (!$scope.activity) {
      cov_172wm16s2f.b[30][0]++;
      cov_172wm16s2f.s[127]++;

      return;
    } else {
      cov_172wm16s2f.b[30][1]++;
    }
    cov_172wm16s2f.s[128]++;
    getInformation({}, function (data) {
      cov_172wm16s2f.f[27]++;
      cov_172wm16s2f.s[129]++;

      $scope.globalValue = data;
      cov_172wm16s2f.s[130]++;
      $('#budget_rate_chart').html('');
      cov_172wm16s2f.s[131]++;
      $('#physique_rate_chart').html('');
      cov_172wm16s2f.s[132]++;
      $('#avanc_rate_chart').html('');

      cov_172wm16s2f.s[133]++;

      if ($scope.globalValue.BB) {
        cov_172wm16s2f.b[31][0]++;

        var circularGauge = (cov_172wm16s2f.s[134]++, new ej.circulargauge.CircularGauge({
          height: '150px',
          width: '150px',
          axes: [{
            labelStyle: { font: { size: '0px' } }, majorTicks: { height: 0 }, minorTicks: { height: 0 },
            startAngle: 180, endAngle: 180, minimum: 0, maximum: 100, radius: '100%',

            ranges: [{
              start: 0, end: 100,
              radius: '0%',
              startWidth: 10, endWidth: 10,
              color: '#E0E0E000',
              opacity: 0
            }],
            annotations: [{
              content: '<div class="jauge-annotation" style="color: ' + getColor($scope.globalValue.TB > 100 ? (cov_172wm16s2f.b[32][0]++, 100) : (cov_172wm16s2f.b[32][1]++, $scope.globalValue.TB), 2) + '">' + $filter('number')($scope.globalValue.TB, 2) + '%</div>',
              angle: 180, zIndex: 1,
              radius: '0%'
            }],
            pointers: [{
              value: $scope.globalValue.TB > 100 ? (cov_172wm16s2f.b[33][0]++, 100) : (cov_172wm16s2f.b[33][1]++, $scope.globalValue.TB),
              type: 'RangeBar',
              radius: '100%',
              color: getColor($scope.globalValue.TB > 100 ? (cov_172wm16s2f.b[34][0]++, 100) : (cov_172wm16s2f.b[34][1]++, $scope.globalValue.TB), 2),
              pointerWidth: 16,
              roundedCornerRadius: $scope.globalValue.TB >= 100 ? (cov_172wm16s2f.b[35][0]++, 0) : (cov_172wm16s2f.b[35][1]++, 8),
              opacity: 0,
              cap: {
                radius: 0
              }
            }]
          }]
        }));
        cov_172wm16s2f.s[135]++;
        circularGauge.appendTo('#budget_rate_chart');
      } else {
        cov_172wm16s2f.b[31][1]++;
      }
      cov_172wm16s2f.s[136]++;

      if ($scope.globalValue.TP) {
        cov_172wm16s2f.b[36][0]++;

        var _circularGauge = (cov_172wm16s2f.s[137]++, new ej.circulargauge.CircularGauge({
          height: '150px',
          width: '150px',
          axes: [{
            labelStyle: { font: { size: '0px' } }, majorTicks: { height: 0 }, minorTicks: { height: 0 },
            startAngle: 180, endAngle: 180, minimum: 0, maximum: 100, radius: '100%',
            ranges: [{
              start: 0, end: 100,
              radius: '100%',
              startWidth: 10, endWidth: 10,
              color: '#E0E0E000'
            }],
            annotations: [{
              content: '<div class="jauge-annotation"  style="color: ' + getColor($scope.globalValue.TP > 100 ? (cov_172wm16s2f.b[37][0]++, 100) : (cov_172wm16s2f.b[37][1]++, $scope.globalValue.TP), 1) + '">' + $filter('number')($scope.globalValue.TP, 2) + '%</div>',
              angle: 50, zIndex: 1,
              radius: '0%'
            }],
            pointers: [{
              value: $scope.globalValue.TP > 100 ? (cov_172wm16s2f.b[38][0]++, 100) : (cov_172wm16s2f.b[38][1]++, $scope.globalValue.TP),
              type: 'RangeBar',
              radius: '100%',
              color: getColor($scope.globalValue.TP > 100 ? (cov_172wm16s2f.b[39][0]++, 100) : (cov_172wm16s2f.b[39][1]++, $scope.globalValue.TP), 1),
              pointerWidth: 16,
              roundedCornerRadius: $scope.globalValue.TP >= 100 ? (cov_172wm16s2f.b[40][0]++, 0) : (cov_172wm16s2f.b[40][1]++, 8)
            }]
          }]
        }));
        cov_172wm16s2f.s[138]++;
        _circularGauge.appendTo('#physique_rate_chart');
      } else {
        cov_172wm16s2f.b[36][1]++;
      }
      cov_172wm16s2f.s[139]++;

      if ((cov_172wm16s2f.b[42][0]++, $scope.globalValue.DD) && (cov_172wm16s2f.b[42][1]++, $scope.globalValue.DF)) {
        cov_172wm16s2f.b[41][0]++;

        var dd = (cov_172wm16s2f.s[140]++, Date.newDate($scope.globalValue.DD).getTime());
        var df = (cov_172wm16s2f.s[141]++, Date.newDate($scope.globalValue.DF).getTime());
        var actual = (cov_172wm16s2f.s[142]++, Date.newDate().getTime());
        var avance = (cov_172wm16s2f.s[143]++, null);
        cov_172wm16s2f.s[144]++;
        if (df - dd != 0) {
          cov_172wm16s2f.b[43][0]++;
          cov_172wm16s2f.s[145]++;

          avance = 100 * (actual - dd) / (df - dd);
          cov_172wm16s2f.s[146]++;
          if (avance > 100) {
            cov_172wm16s2f.b[44][0]++;
            cov_172wm16s2f.s[147]++;

            avance = 100;
          } else {
            cov_172wm16s2f.b[44][1]++;
          }
          cov_172wm16s2f.s[148]++;
          if (avance < 0) {
            cov_172wm16s2f.b[45][0]++;
            cov_172wm16s2f.s[149]++;

            avance = 0;
          } else {
            cov_172wm16s2f.b[45][1]++;
          }
          var _circularGauge2 = (cov_172wm16s2f.s[150]++, new ej.circulargauge.CircularGauge({
            height: '150px',
            width: '150px',
            axes: [{
              labelStyle: { font: { size: '0px' } }, majorTicks: { height: 0 }, minorTicks: { height: 0 },
              startAngle: 180, endAngle: 180, minimum: 0, maximum: 100, radius: '100%',
              ranges: [{
                start: 0, end: 100,
                radius: '100%',
                startWidth: 10, endWidth: 10,
                color: '#E0E0E000'
              }],
              annotations: [{
                content: '<div class="jauge-annotation"  style="color: ' + getColor(avance, 2) + '">' + $filter('number')(avance, 2) + '%</div>',
                angle: 180, zIndex: 1,
                radius: '0%'
              }],
              pointers: [{
                value: avance,
                type: 'RangeBar',
                radius: '100%',
                color: getColor(avance, 2),
                pointerWidth: 16,
                roundedCornerRadius: avance >= 100 ? (cov_172wm16s2f.b[46][0]++, 0) : (cov_172wm16s2f.b[46][1]++, 8)
              }]
            }]
          }));
          cov_172wm16s2f.s[151]++;
          _circularGauge2.appendTo('#avanc_rate_chart');
        } else {
          cov_172wm16s2f.b[43][1]++;
        }
      } else {
        cov_172wm16s2f.b[41][1]++;
      }
    });
  };

  cov_172wm16s2f.s[152]++;
  $scope.getChartInformations = function () {
    cov_172wm16s2f.f[28]++;
    cov_172wm16s2f.s[153]++;

    if (!$scope.activity) {
      cov_172wm16s2f.b[47][0]++;
      cov_172wm16s2f.s[154]++;

      return;
    } else {
      cov_172wm16s2f.b[47][1]++;
    }

    cov_172wm16s2f.s[155]++;
    getInformation({
      get: 'chart_informations',
      a2: $scope.choise.displayIndex == 0 ? (cov_172wm16s2f.b[48][0]++, '0_0_0') : (cov_172wm16s2f.b[48][1]++, $scope.choise.displayIndex + '_1_1'),
      la2: $scope.choise.displayIndex == 0 ? (cov_172wm16s2f.b[49][0]++, 1) : (cov_172wm16s2f.b[49][1]++, 2)
    }, function (data) {
      cov_172wm16s2f.f[29]++;
      cov_172wm16s2f.s[156]++;

      data = data.sort(function (valueA, valueB) {
        cov_172wm16s2f.f[30]++;
        cov_172wm16s2f.s[157]++;

        return valueA.id > valueB.id ? (cov_172wm16s2f.b[50][0]++, 1) : (cov_172wm16s2f.b[50][1]++, -1);
      });

      cov_172wm16s2f.s[158]++;
      data = data.map(function (value) {
        cov_172wm16s2f.f[31]++;

        var ids = (cov_172wm16s2f.s[159]++, value.id.split('_'));
        cov_172wm16s2f.s[160]++;
        value.label = ids[0];
        cov_172wm16s2f.s[161]++;
        if ($scope.choise.displayIndex != 0) {
          cov_172wm16s2f.b[51][0]++;
          cov_172wm16s2f.s[162]++;

          value.label = $deltadate.getLabelPerioddepth(ids[1], ids[2]);
        } else {
          cov_172wm16s2f.b[51][1]++;
        }
        cov_172wm16s2f.s[163]++;
        return value;
      });

      cov_172wm16s2f.s[164]++;
      $scope.chartPanel = {
        primaryXAxis: {
          title: '',
          interval: 1,
          labelIntersectAction: 'Rotate45',
          valueType: 'Category',
          majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
          majorTickLines: { width: 0 }, minorTickLines: { width: 0 }
        },

        primaryYAxis: {
          title: '',
          valueType: 'Double',
          labelFormat: '{value} %'
        },
        chartArea: {
          border: {
            width: 0
          }
        },

        series: [{
          type: 'Column',
          fill: 'rgb(68, 114, 196)',
          dataSource: data.map(function (value) {
            cov_172wm16s2f.f[32]++;

            var d_ = (cov_172wm16s2f.s[165]++, { x: value.label, y: null });
            cov_172wm16s2f.s[166]++;
            if (value.BB) {
              cov_172wm16s2f.b[52][0]++;
              cov_172wm16s2f.s[167]++;

              d_.y = value.TB;
            } else {
              cov_172wm16s2f.b[52][1]++;
            }
            cov_172wm16s2f.s[168]++;
            return d_;
          }),
          xName: 'x', yName: 'y', name: $translate.instant('ANALYSE.FIELDS.BUDGET.T')
        }, {
          fill: 'rgb(237, 125, 49)',
          type: 'Line',
          dataSource: data.map(function (value) {
            cov_172wm16s2f.f[33]++;

            var d_ = (cov_172wm16s2f.s[169]++, { x: value.label, y: null });
            cov_172wm16s2f.s[170]++;
            if (value.TP) {
              cov_172wm16s2f.b[53][0]++;
              cov_172wm16s2f.s[171]++;

              d_.y = value.TP;
            } else {
              cov_172wm16s2f.b[53][1]++;
            }
            cov_172wm16s2f.s[172]++;
            return d_;
          }),
          xName: 'x', yName: 'y', name: $translate.instant('ANALYSE.FIELDS.PHYSIC.T'),
          width: 2,
          marker: {
            visible: true,
            width: 10,
            height: 10
          }
        }],
        width: '100%',
        height: 'calc(100% - 45px)',
        tooltip: {
          enable: true
        }

      };
    });
  };

  cov_172wm16s2f.s[173]++;
  var initMap = function initMap() {
    cov_172wm16s2f.f[34]++;

    var myMap = (cov_172wm16s2f.s[174]++, L.map('map', { fullscreenControl: {
        title: {
          false: $translate.instant('COMMON.FULLSCREEN'),
          true: $translate.instant('COMMON.EXIT_FULLSCREEN')
        }
      }, layers: [] }).setView([16.82, 11.3], 5));

    cov_172wm16s2f.s[175]++;
    $rootScope.getTileLayers(myMap, 'COMMON.GRAYSCALE');
    cov_172wm16s2f.s[176]++;
    $scope.layersGroup = L.layerGroup();

    cov_172wm16s2f.s[177]++;
    $scope.layersGroup.addTo(myMap);
    var legendMap = (cov_172wm16s2f.s[178]++, getColors(1));
    var legendControl = (cov_172wm16s2f.s[179]++, L.control({ position: 'bottomright' }));
    cov_172wm16s2f.s[180]++;
    legendControl.onAdd = function (map) {
      cov_172wm16s2f.f[35]++;

      var div = (cov_172wm16s2f.s[181]++, L.DomUtil.create('div', 'info legend'));
      cov_172wm16s2f.s[182]++;

      for (var i = 0; i < legendMap.length; i++) {
        cov_172wm16s2f.s[183]++;

        div.innerHTML += '<i style="background:' + legendMap[i].color + '"></i> ' + $filter('number')(legendMap[i - 1] ? (cov_172wm16s2f.b[54][0]++, legendMap[i - 1].valueMax) : (cov_172wm16s2f.b[54][1]++, 0)) + (legendMap[i + 1] ? (cov_172wm16s2f.b[55][0]++, ' &ndash; ' + $filter('number')(legendMap[i].valueMax)) : (cov_172wm16s2f.b[55][1]++, ' +')) + (legendMap[i].l ? (cov_172wm16s2f.b[56][0]++, ' <smal style="font-weight: normal; font-size: 10px" >(' + legendMap[i].l + ')</smal>') : (cov_172wm16s2f.b[56][1]++, '')) + '<br>';
      }
      cov_172wm16s2f.s[184]++;
      return div;
    };
    cov_172wm16s2f.s[185]++;
    legendControl.addTo(myMap);
  };
  cov_172wm16s2f.s[186]++;
  var processLayer = function processLayer(locality, geojson) {
    cov_172wm16s2f.f[36]++;
    cov_172wm16s2f.s[187]++;

    geojson.properties = { code: locality.CODE_LC };
    var l = (cov_172wm16s2f.s[188]++, L.geoJSON(geojson, {
      info: { code: locality.CODE_LC },
      pointToLayer: function pointToLayer(point, latlng) {
        cov_172wm16s2f.s[189]++;

        return L.circle(latlng, { radius: 15000 });
      },
      onEachFeature: function onEachFeature(feature, layer) {
        cov_172wm16s2f.s[190]++;

        layer.on({
          click: function click() {}
        });
      },
      style: function style(feature) {
        cov_172wm16s2f.s[191]++;

        return {
          fillColor: '#f1c120',
          weight: 2,
          opacity: 1,
          color: '#f1c120',
          dashArray: '3',
          fillOpacity: 0.1
        };
      }
    }));
    cov_172wm16s2f.s[192]++;
    l.on('add', function (element) {
      cov_172wm16s2f.f[37]++;
      cov_172wm16s2f.s[193]++;

      locality.layerId = element.target._leaflet_id;
      cov_172wm16s2f.s[194]++;
      customlayers(locality.layerId, $scope.mapData[locality.CODE_LC]);
    });
    cov_172wm16s2f.s[195]++;
    l.addTo($scope.layersGroup);
    cov_172wm16s2f.s[196]++;
    l.bringToFront();
    cov_172wm16s2f.s[197]++;
    return l.getBounds();
  };

  cov_172wm16s2f.s[198]++;
  var processLayers = function processLayers() {
    cov_172wm16s2f.f[38]++;

    var localities = (cov_172wm16s2f.s[199]++, {});
    var ids = (cov_172wm16s2f.s[200]++, []);
    cov_172wm16s2f.s[201]++;
    for (var key_locality in $scope.mappingLocatities) {
      var uid_arc = (cov_172wm16s2f.s[202]++, $scope.mappingLocatities[key_locality].UID_ARC);
      cov_172wm16s2f.s[203]++;
      if (!uid_arc) {
        cov_172wm16s2f.b[57][0]++;
        cov_172wm16s2f.s[204]++;

        continue;
      } else {
        cov_172wm16s2f.b[57][1]++;
      }
      cov_172wm16s2f.s[205]++;
      ids.push(uid_arc);
      cov_172wm16s2f.s[206]++;
      localities[uid_arc] = key_locality;
    }

    var params = (cov_172wm16s2f.s[207]++, {
      where: '1 = 1',
      objectIds: ids,
      time: '',
      geometry: '',
      geometryType: 'esriGeometryEnvelope',
      inSR: '',
      spatialRel: 'esriSpatialRelIntersects',
      resultType: 'none',
      distance: '0.0',
      units: 'esriSRUnit_Meter',
      returnGeodetic: false,
      outFields: 'FID',
      returnHiddenFields: false,
      returnGeometry: true,
      returnCentroid: false,
      featureEncoding: 'esriDefault',
      multipatchOption: 'xyFootprint',
      maxAllowableOffset: '',
      geometryPrecision: '',
      outSR: '4326',
      datumTransformation: '',
      applyVCSProjection: false,
      returnIdsOnly: false,
      returnUniqueIdsOnly: false,
      returnCountOnly: false,
      returnExtentOnly: false,
      returnQueryGeometry: false,
      returnDistinctValues: false,
      cacheHint: false,
      orderByFields: '',
      groupByFieldsForStatistics: '',
      outStatistics: '',
      having: '',
      resultOffset: '',
      resultRecordCount: '',
      returnZ: false,
      returnM: false,
      returnExceededLimitFeatures: true,
      quantizationParameters: '',
      sqlFormat: 'none',
      f: 'pgeojson'
    });

    cov_172wm16s2f.s[208]++;
    $rootScope.loadGeojson($scope.mapGeoLevel.NIVEAU_NG - 1, ids, function (responseData) {
      cov_172wm16s2f.f[39]++;

      var bounds = (cov_172wm16s2f.s[209]++, null);
      cov_172wm16s2f.s[210]++;
      for (var _iterator = responseData.features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var geojson = _ref;

        var child = (cov_172wm16s2f.s[211]++, $scope.mappingLocatities[localities[geojson.id]]);
        var my_bound = (cov_172wm16s2f.s[212]++, processLayer(child, geojson));
        cov_172wm16s2f.s[213]++;

        if (!bounds) {
          cov_172wm16s2f.b[58][0]++;
          cov_172wm16s2f.s[214]++;

          bounds = my_bound;
        } else {
          cov_172wm16s2f.b[58][1]++;
          cov_172wm16s2f.s[215]++;

          bounds.extend(my_bound);
        }
      }
      cov_172wm16s2f.s[216]++;
      if (bounds) {
        cov_172wm16s2f.b[59][0]++;
        cov_172wm16s2f.s[217]++;

        $scope.layersGroup._map.fitBounds(bounds);
      } else {
        cov_172wm16s2f.b[59][1]++;
      }
    });
  };

  cov_172wm16s2f.s[218]++;
  $scope.getMapInformations = function () {
    cov_172wm16s2f.f[40]++;
    cov_172wm16s2f.s[219]++;

    if (!$scope.layersGroup) {
      cov_172wm16s2f.b[60][0]++;
      cov_172wm16s2f.s[220]++;

      initMap();
    } else {
      cov_172wm16s2f.b[60][1]++;
    }

    var params = (cov_172wm16s2f.s[221]++, { get: 'all_geo_idoms', activity: $scope.activity.id });
    cov_172wm16s2f.s[222]++;
    if ($scope.mapGeoLevel) {
      cov_172wm16s2f.b[61][0]++;
      cov_172wm16s2f.s[223]++;

      params.level = $scope.mapGeoLevel.id;
    } else {
      cov_172wm16s2f.b[61][1]++;
    }
    cov_172wm16s2f.s[224]++;
    $scope.mapData = {};
    cov_172wm16s2f.s[225]++;
    getInformation({
      get: 'map_informations',
      level: ((cov_172wm16s2f.b[62][0]++, $scope.mapGeoLevel) || (cov_172wm16s2f.b[62][1]++, { NIVEAU_NG: 1 })).NIVEAU_NG - 1,
      year: $scope.choise.displayIndex
    }, function (data) {
      cov_172wm16s2f.f[41]++;
      cov_172wm16s2f.s[226]++;

      $scope.mapData = data;

      cov_172wm16s2f.s[227]++;
      if ((cov_172wm16s2f.b[64][0]++, $scope.mappingLocatities) && (cov_172wm16s2f.b[64][1]++, _typeof($scope.mapData) == 'object') && (cov_172wm16s2f.b[64][2]++, Object.keys($scope.mapData).length > 0)) {
        cov_172wm16s2f.b[63][0]++;
        cov_172wm16s2f.s[228]++;

        for (var key_locality in $scope.mappingLocatities) {
          var locality = (cov_172wm16s2f.s[229]++, $scope.mappingLocatities[key_locality]);
          cov_172wm16s2f.s[230]++;
          customlayers(locality.layerId, $scope.mapData[locality.CODE_LC]);
        }
      } else {
          cov_172wm16s2f.b[63][1]++;
          cov_172wm16s2f.s[231]++;
          if (Object.keys($scope.mapData).length == 0) {
            cov_172wm16s2f.b[65][0]++;
            cov_172wm16s2f.s[232]++;

            $scope.mappingLocatities = null;
            cov_172wm16s2f.s[233]++;
            $scope.layersGroup.clearLayers();
            cov_172wm16s2f.s[234]++;
            return;
          } else {
            cov_172wm16s2f.b[65][1]++;
          }
        }cov_172wm16s2f.s[235]++;
      if (!$scope.mappingLocatities) {
        cov_172wm16s2f.b[66][0]++;
        cov_172wm16s2f.s[236]++;

        $scope.layersGroup.clearLayers();
        cov_172wm16s2f.s[237]++;


        $CRUDService.getAll(PATH_LOCALITY, params, function (localities) {
          cov_172wm16s2f.f[42]++;
          cov_172wm16s2f.s[238]++;

          $scope.mappingLocatities = {};
          cov_172wm16s2f.s[239]++;
          for (var _iterator2 = localities, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
              if (_i2 >= _iterator2.length) break;
              _ref2 = _iterator2[_i2++];
            } else {
              _i2 = _iterator2.next();
              if (_i2.done) break;
              _ref2 = _i2.value;
            }

            var _locality = _ref2;
            cov_172wm16s2f.s[240]++;

            $scope.mappingLocatities[_locality.CODE_LC] = _locality;
          }
          cov_172wm16s2f.s[241]++;
          if ((cov_172wm16s2f.b[68][0]++, $scope.mapData.length != 0) && (cov_172wm16s2f.b[68][1]++, $scope.mapData != {})) {
            cov_172wm16s2f.b[67][0]++;
            cov_172wm16s2f.s[242]++;

            processLayers();
          } else {
            cov_172wm16s2f.b[67][1]++;
          }
        });
      } else {
        cov_172wm16s2f.b[66][1]++;
      }
    });
  };
  cov_172wm16s2f.s[243]++;
  $deltaGeoLevel.addController($scope, function () {
    cov_172wm16s2f.f[43]++;

    var levelSaved = (cov_172wm16s2f.s[244]++, (cov_172wm16s2f.b[69][0]++, localStorage.getItem(ACTIVITY_DASHBOARD_PROJECT_GLOBAL_GEO_PLAN)) || (cov_172wm16s2f.b[69][1]++, 0));
    cov_172wm16s2f.s[245]++;
    $scope.mapGeoLevel = (cov_172wm16s2f.b[70][0]++, $scope.listData_GeoLevels_bksb.find(function (level) {
      cov_172wm16s2f.f[44]++;
      cov_172wm16s2f.s[246]++;
      return level.id === levelSaved;
    })) || (cov_172wm16s2f.b[70][1]++, $scope.listData_GeoLevels_bksb[0]);
  });

  cov_172wm16s2f.s[247]++;
  $scope.search_activity = '';
  cov_172wm16s2f.s[248]++;
  $scope.clone_listData = null;
  cov_172wm16s2f.s[249]++;
  $scope.filterActivity = function () {
    cov_172wm16s2f.f[45]++;
    cov_172wm16s2f.s[250]++;

    if ($scope.search_activity != '') {
      cov_172wm16s2f.b[71][0]++;
      cov_172wm16s2f.s[251]++;

      $scope.listData = $scope.listData.filter(function (value) {
        cov_172wm16s2f.f[46]++;
        cov_172wm16s2f.s[252]++;

        return (value.CODE_CLCAFF + ' ' + value.LIBELLE_C_CL).toLowerCase().includes($scope.search_activity.toLowerCase());
      });
    } else {
      cov_172wm16s2f.b[71][1]++;
      cov_172wm16s2f.s[253]++;

      $scope.listData = angular.copy($scope.clone_listData);
    }
  };

  cov_172wm16s2f.s[254]++;
  $CRUDService.getAll(PATH_CL, { get: 'all_activities' }, function (data) {
    cov_172wm16s2f.f[47]++;
    cov_172wm16s2f.s[255]++;

    $scope.listData = data;
    cov_172wm16s2f.s[256]++;
    $scope.clone_listData = angular.copy(data);

    var selectActivity = (cov_172wm16s2f.s[257]++, localStorage.getItem(ACTIVITY_DASHBOARD_PROJECT_GLOBAL_ACTIVITY));

    cov_172wm16s2f.s[258]++;
    $scope.getAllInformations((cov_172wm16s2f.b[72][0]++, $scope.listData.find(function (activity) {
      cov_172wm16s2f.f[48]++;
      cov_172wm16s2f.s[259]++;
      return activity.id == selectActivity;
    })) || (cov_172wm16s2f.b[72][1]++, $scope.listData[0]));
  });
});